export default {
  certifications: {
    title: "Acreditações",
    text: "NED College tem o orgulho de se associar a grandes instituições para garantir o alto padrão de qualidade que nossos alunos procuram.",
  },
  studywithus: {
    header: {
      title: `<span class="text-green">Estude Inglês e Trabalhe</span>
        <span class="text-white"> na Irlanda com a NED College</span>`,
      subtitle: `Comece a sua jornada agora!`,
    },
    form: {
      title: "Comece a sua jornada agora!",
      name: `Seu Nome Completo`,
      email: `Seu melhor e-mail`,
      whatsapp: `Seu WhatsApp`,
      nationality: `Por favor escolha a sua nacionalidade`,
      campus: `Qual campus você quer estudar?`,
      button: `Solicite seu orçamento!`,
    },
    section1: {
      title: `Por que escolher a Irlanda para fazer seu intercâmbio?`,
      items: [
        `Possibilidade de <b>estudar e trabalhar</b> legalmente`,
        `Um dos <b>salários mínimos mais altos</b> da Europa`,
        `<b>Facilidade no processo de visto</b>, feito diretamente na Irlanda após sua chegada`,
        `Chance de <b>viajar para diversos países</b> pela Europa`,
      ],
    },
    section2: {
      title: `Há mais de <span class="text-green">10 anos no mercado</span>,
        a <span class="text-blue5">NED College</span> é uma escola de Inglês na Irlanda que recebe intercambistas
        de <span class="text-blue5">+30 diferentes nacionalidades</span>`,
      subtitle: `Com dois campus no país, nós proporcionamos uma <span class="text-blue5">experiência extraordinária</span>
        para os nossos alunos e oferecemos um <span class="text-green">ensino de excelência acadêmica</span>`,
      button: "Quero estudar na NED College",
    },
    section3: {
      dublin: {
        title: "Dublin Campus",
        subtitle:
          "Localizada no coração da cidade, com fácil acesso por transporte público, dentro de dois prédios históricos, construídos em 1750.",
        button: "Quero estudar em Dublin",
      },
      limerick: {
        title: "Limerick Campus",
        subtitle:
          "Localizado no centro de Limerick, com fácil acesso a pé para os principais pontos turísticos da cidade, em um prédio que oferece instalações modernas e acessibilidade.",
        button: "Quero estudar em Limerick",
      },
    },
    section4: {
      title: "Por que escolher a NED College para fazer intercâmbio na Irlanda?",
      items: [
        {
          img: "/landings/landing_0823/imgs/services_01.png",
          text: "<b>Kit, Reunião e Tour</b> de boas-vindas",
        },
        {
          img: "/landings/landing_0823/imgs/services_02.png",
          text: "<b>Imersão</b> Cultural",
        },
        {
          img: "/landings/landing_0823/imgs/services_03.png",
          text: "Consultoria no seu <b>próprio idioma</b>",
        },
        {
          img: "/landings/landing_0823/imgs/services_04.png",
          text: "Atividades e <b>Viagens</b>",
        },
        {
          img: "/landings/landing_0823/imgs/services_05.jpeg",
          text: "Professores <b>Qualificados</b>",
        },
        {
          img: "/landings/landing_0823/imgs/services_06.jpeg",
          text: "Aulas <b>Extra Curriculares</b>",
          description: "(Conversação, Pronúncia e etc)",
        },
        {
          img: "/landings/landing_0823/imgs/services_07.jpeg",
          text: "<b>Workshops e Cursos</b> profissionalizantes",
        },
        {
          img: "/landings/landing_0823/imgs/services_08.jpeg",
          text: "<b>Apoio ao aluno</b> na Irlanda",
        },
        {
          img: "/landings/landing_0823/imgs/services_09.jpeg",
          text: "<b>Flexibilidade</b> no pagamento",
        },
        {
          img: "/landings/landing_0823/imgs/services_10.png",
          text: "<b>APP exclusivo</b> NED College",
        },
        {
          img: "/landings/landing_0823/imgs/services_11.png",
          text: "Descontos em <b>empresas parceiras</b>",
        },
      ],
      button: "Quero estudar na NED College",
    },
    section5: {
      title: "O que nossos alunos estão dizendo?",
      button: "Solicite um orçamento!",
    },
    section6: {
      button: "Quero estudar na NED College",
    },
  },
  studywithus_thanks: {
    title: `Obrigado pelo seu interesse na <span class="text-green">NED College!</span>`,
    subtitle: `Recebemos os seus dados e vamos <span class="text-green2">entrar em contato em breve.</span>`,
    description: `Agora que você deu o primeiro passo, <span class="text-blue2">aproveite para descobrir mais sobre a nossa
      escola de inglês</span> e explorar como é a vida de um intercambista com a NED College.`,
    socials_title: "Siga as nossas redes sociais",
  },

  home: {
    header: {
      title1: "Estude Inglês na Irlanda",
      title2: "com a NED College",
      subtitle: "Cursos de inglês feitos para você!",
    },
    section1: {
      title1: "Uma nova jornada está prestes a começar",
      title2:
        "Fundada em 2011, esta Escola de Inglês possui dois campi na Irlanda: Dublin e Limerick",
      title3:
        "Nós temos a honra de dizer que ajudamos mais de 13.000 estudantes de 33 nações diferentes ao redor do mundo a aprender inglês e vivenciar experiências incríveis na Irlanda.",
      button: "Eu quero começar minha nova jornada",
    },
    splitted_section: {
      title1: "Campus de Dublin",
      text1:
        "A escola está localizada no coração da cidade, acessível por meio de vários serviços de transporte público ou a pé, dentro de dois edifícios históricos e lindos, construídos em 1750!",
      button1: "Eu quero saber mais",
      title2: "Campus de Limerick",
      text2:
        "Nosso segundo Campus também está localizado no coração da cidade de Limerick, em um edifício bonito e moderno, com instalações completamente novas e modernas!",
      button2: "Eu quero saber mais",
    },
    section_courses: {
      title: "Confira nossos cursos de inglês",
      text: "Escolha o curso que melhor se adequa a você e comece sua jornada conosco!",
      button: "Descubra todos os cursos",
      first_card_title: "Curso de Inglês de Longo Prazo",
      first_card_text:
        "O curso mais amado e escolhido pelos estudantes! Este programa lhe dará a oportunidade de obter um visto que permite estudar e trabalhar legalmente por 8 meses.",
      second_card_title: "Curso de Inglês de Curto Prazo",
      second_card_text:
        "Ideal para estudantes que desejam aprimorar e praticar o idioma em um curto período de tempo.",
      third_card_title: "Inglês Geral + IELTS",
      third_card_text:
        "Curso de Preparação para o IELTS. O IELTS (Sistema Internacional de Teste de Língua Inglesa) é projetado para ajudá-lo a trabalhar, estudar ou migrar para um país onde o inglês é a língua nativa.",
    },
    studentlife: {
      title: "Vida de Estudante",
      text: "Nossa escola oferece muito mais do que cursos de inglês, oferecemos a experiência completa!",
      activities1: "Atividades, excursões",
      activities2: "e",
      activities3: "Aulas extracurriculares",
      app: "Aplicativo Exclusivo",
      app2: "para estudantes da NED College",
      accomodation1: "Acomodação Temporária",
      accomodation2: " na Irlanda",
      airport1: "Transfer",
      airport2: "do Aeroporto",
      button: "Saiba mais sobre nossos serviços",
    },
    modal: {
      image: "",
      imageMobile: "",
    },
  },
  ned_college: {
    title: "<span class='text-green2'>Escola de Inglês</span> na Irlanda",
    breadcr: ["Sobre Nós", ">", "NED College"],
    section1: {
      title1: "NED College é uma Escola de Inglês",
      title2: " com base na Irlanda",
      text1:
        "Desde 2011, temos ajudado estudantes de todo o mundo a melhorar seu inglês, se conectar com novas pessoas e um novo mundo, oferecendo o aprendizado de melhor qualidade enquanto têm uma experiência incrível na Irlanda.",
      text2:
        "Há mais de 10 anos, nossa equipe tem trabalhado duro para fornecer o melhor para nossos estudantes, oferecendo-lhes muito mais do que apenas aulas de inglês: uma EXPERIÊNCIA INESQUECÍVEL!",
      text3:
        "Atualmente, o NED College tem duas unidades no país; uma em Dublin e outra em Limerick, e em cada uma delas, você encontrará as instalações ideais para garantir a melhor experiência educacional no exterior.",
    },
    section2: {
      title: "Recebendo estudantes de todo o mundo",
      text: "Uma ambiente multicultural, com pessoas, culturas e origens diferentes, é a melhor maneira de aprender/melhorar um novo idioma. No NED College, temos investido nesse princípio desde 2010. Já ajudamos mais de 12 mil estudantes de mais de 30 países a melhorar seu inglês, além de desfrutar de uma experiência que nunca esquecerão.",
    },
    section3: {
      title1: "Se estudar no exterior sempre foi um de seus sonhos,",
      title2: "você está no lugar certo para torná-lo realidade!",
      button: "Quero realizar meu sonho",
    },
    section4: {
      title: "Por que escolher o NED College?",
      text1: "+10 anos na área da educação",
      text2: "Suporte ao estudante em seu próprio idioma",
      text3: "+12.000 pessoas já estudaram conosco",
      text4: "Mais de 33 nacionalidades",
      text5: "Duas unidades: Dublin e Limerick",
      text6: "Professores plenamente qualificados",
      button: "Inicie sua jornada na Irlanda com o NED College!",
    },
    section5: {
      title:
        "Todos os nossos professores possuem pelo menos um diploma de graduação e uma qualificação reconhecida em Ensino de Língua Inglesa.",
      text: "Todos os nossos professores são profissionais. Muitos já ensinaram não apenas na Irlanda, mas também no exterior, e trazem uma vasta experiência para a sala de aula para garantir que seu tempo conosco seja educativo, envolvente e divertido.",
    },
    section6: {
      title1: "Unidade Dublin",
      text1:
        "Localizada no coração da cidade, dentro de dois belos prédios históricos, construídos em 1750. Esta localização tem sido a casa do NED College há mais de 10 anos!",
      button1: "Escolho Dublin!",
      circle1: "Escolhendo",
      circle2: "entre",
      title2: "Unidade Limerick",
      text2:
        "Nossa segunda unidade está localizada no coração da cidade de Limerick, em um belo prédio, com instalações completamente novas e modernas!",
      button2: "Escolho Limerick!",
    },
    section7: {
      title: "Missão, Ética e Valores do NED College",
      subtitle:
        "A alta administração e os diretores da empresa redefiniram nossa declaração de missão após um período de consulta para melhor refletir nossos valores.",
      subtitle1: "Declaração de Missão",
      text1:
        "Nossa missão é ser a primeira opção para estudantes de inglês, oferecendo uma experiência de aprendizado de alta qualidade e excelência no ensino de idiomas. Nossa equipe trabalha em parceria, onde as necessidades de nossos estudantes, que estão no centro de nossas ações diárias, visam o desenvolvimento da comunidade do NED College como um todo.",
      text2:
        "Esforçamo-nos para oferecer uma abordagem à educação em língua inglesa que reflita e atenda às necessidades de nossa diversa comunidade estudantil, criando um ambiente de aprendizado positivo e divertido, fundamentado nas melhores práticas, que seja inclusivo e de apoio, garantindo que nossos alunos alcancem seus objetivos acadêmicos.",
      subtitle2: "Ética",
      text3:
        "A ética do NED College é fundamentada em nossos valores centrais de comunidade, relevância individual, solidariedade grupal, diversidade, excelência no ensino e respeito por todos. Nossa equipe trabalha em parceria para construir rapport com cada aluno, desenvolvendo um senso de relevância individual e solideriedade dentro de nossa comunidade do College dentro e fora da sala de aula.",
      text4:
        "Oferecemos treinamento e desenvolvimento focados para garantir que estamos entregando excelência no ensino, em conformidade com a legislação e padrões exigidos, alinhados às melhores práticas da indústria. Acreditamos em tratar a todos de forma justa e ética, e isso se reflete em nosso logotipo de ética.",
      subtitle3: "Neste sentido, o NED College está comprometido em:",
      list1: "Promover a igualdade para todos os estudantes",
      list2: "Avaliar os estudantes de forma justa e consistente",
      list3:
        "Fornecer oportunidades para feedback e lidar com quaisquer problemas de maneira profissional e oportuna",
      list4:
        "Cumprir as diretrizes e obrigações legislativas aplicáveis e implementar recomendações e diretrizes à medida que forem surgindo.",
    },
    section8: {
      text1:
        "O NED College proporciona uma experiência culturalmente imersiva, onde os estudantes são apoiados em todos os níveis,",
      text2:
        "abraçando a diversidade e ajudando os estudantes a se integrarem na sociedade irlandesa para aproveitar ao máximo sua experiência de aprendizado.",
    },
    testimonial: {
      title: "Veja o que nossos estudantes estão dizendo sobre o NED College",
    },
  },
  courses: {
    title: "Cursos de Inglês na Irlanda",
    breadcr: ["Cursos"],
    section1: {
      title1: "Maximize seu potencial com nossos cursos de inglês para adultos",
      subtitle1:
        "No NED College, queremos lhe dar a melhor oportunidade possível, seja para aprender e avançar em sua carreira, desenvolver suas habilidades pessoais ou viajar com confiança.",
      title2: "Cursos de Inglês Geral",
      text1: "Se você gostaria de ter uma nova",
      text2: "experiência cultural",
      text3:
        "e alcançar o melhor nível possível com aulas intensivas, este curso é para você! Todas as",
      text4: "aulas para adultos",
      text5: "são ministradas 5 dias por semana, de segunda a sexta-feira, com os",
      text6: "melhores professores de inglês experientes",
      cards: [
        {
          color: "blue2",
          tag: "25 semanas",
          title: "Curso de Inglês Geral de Longo Prazo",
          bodyTitle: "",
          body: "\nLeve suas habilidades em inglês para o próximo nível e aproveite essa experiência conosco! Para fazer\neste curso, a maioria dos viajantes precisa solicitar um visto de estudante, que lhes permite\ntrabalhar e estudar legalmente na Irlanda durante sua estadia. Além disso, os alunos podem fazer\nexames de certificação ao final do curso, como o TIE, IELTS, Cambridge e\nTrinity Exams.\n",
          image: null,
          button: "Quero um orçamento!",
        },
        {
          color: "blue3",
          tag: "4, 8 e 12 semanas",
          title: "Curso de Inglês Geral de Curto Prazo",
          bodyTitle: "",
          body: "\nIdeal para estudantes que desejam aprimorar e praticar o idioma em um curto período de tempo, no ambiente perfeito.\n",
          image: null,
          button: "Quero um orçamento!",
        },
        {
          color: "green2",
          tag: "4, 8 e 12 semanas",
          title: "Programa de Inverno Curso de Inglês Geral",
          bodyTitle: "Outubro, Novembro, Janeiro e Fevereiro",
          body: "\nEste programa é recomendado para aqueles que não podem passar um longo período na Irlanda e desejam melhorar suas habilidades em inglês e aproveitar algum tempo na Irlanda.\n",
          image: null,
          button: "Quero um orçamento!",
        },
        {
          color: "green1",
          tag: "4, 8 e 12 semanas",
          title: "Programa de Verão Curso de Inglês Geral",
          bodyTitle: "Junho, julho e agosto",
          body: "\nEste programa é recomendado para aqueles que não podem passar um longo período na Irlanda e desejam melhorar suas habilidades em inglês e aproveitar o verão na Irlanda.\n",
          image: null,
          button: "Quero um orçamento!",
        },
        {
          color: "red",
          tag: "25 semanas",
          title: "Curso de Inglês Geral + Preparação para o IELTS",
          bodyTitle: "",
          body: "\nO International English Language Testing System (IELTS) foi criado para ajudá-lo a trabalhar, estudar ou migrar para um país de língua inglesa.\n",
          image: "logo_ielts",
          button: "Quero um orçamento!",
        },
      ],
    },
    section2: {
      title: "Quem possui um bom nível de habilidade",
      text1:
        "A faculdade NED tem cursos disponíveis para todos os níveis de inglês, desde estudantes que têm pouco ou nenhum conhecimento da língua, até aqueles que possuem um nível bom, mas desejam continuar aprimorando-o. À direita, você pode encontrar uma lista dos diferentes níveis e o tipo de exame de certificação que recomendamos que você faça ao final do curso.",
      text2: "Nível",
      text3: "Tipo de Exame (recomendado)",
      accordion_data: [
        {
          title: "A0 - A1 | Iniciante",
          tag: "TIE",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Estrutura e objetivos do curso",
            },
            {
              type: "p",
              class: "",
              text: "O curso de Inglês Geral Pré A1 é destinado a alunos com pouco ou nenhum conhecimento ou experiência na língua inglesa, com o objetivo de desenvolver as quatro habilidades: leitura, escrita, fala e escuta. Este curso é projetado para desenvolver habilidades básicas em inglês e construir confiança para se comunicar com interlocutores nativos e não nativos no idioma alvo, em uma variedade de assuntos familiares, usando vocabulário cotidiano e estruturas gramaticais simples. É o primeiro passo rumo à eficiência comunicativa. O objetivo do curso A0 é que os alunos progridam para o curso A1, onde poderão desenvolver e consolidar ainda mais suas habilidades na língua e terão elegibilidade para fazer um exame externo. Durante o período de onze semanas, espera-se que os alunos cubram as áreas linguísticas e alcancem os resultados listados abaixo:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "As seguintes competências são atribuídas ao curso Pré A1, ao final do qual os alunos serão capazes de demonstrar as seguintes habilidades:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades de Recepção",
            },
            {
              type: "ul",
              list: [
                "Interagir de maneira simples, desde que a outra pessoa esteja disposta a repetir ou reformular as coisas em um ritmo mais lento e ajudar na formulação.",
                "Compreender a ideia geral de textos informativos simples e descrições curtas e simples, especialmente se contiverem imagens que ajudem a explicar o texto.",
                "Compreender textos curtos e simples, juntando nomes familiares, palavras e frases básicas, por exemplo, relendo partes do texto.",
                "Compreender mensagens curtas e simples, por exemplo, em cartões postais.",
                "Compreender expressões cotidianas que tratam de necessidades cotidianas simples e concretas, em uma fala clara, lenta e repetida.",
                "Compreender perguntas e instruções e seguir direções curtas e simples.",
                "Compreender números, preços e horários.",
                "Seguir instruções curtas e simples por escrito, especialmente se contiverem imagens.",
                "Reconhecer nomes familiares, palavras e frases muito básicas em avisos simples na sala de aula e ao redor da escola.",
                "Entender um discurso que é muito lento e pronunciado com cuidado, com pausas longas para entender o significado",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Produtivas",
            },
            {
              type: "ul",
              list: [
                "Usar frases e sentenças simples para descrever onde moram e pessoas que conhecem.",
                "Fazer e responder perguntas simples em áreas de necessidade imediata ou sobre assuntos muito familiares.",
                "Estabelecer contato social básico usando as formas mais simples e comuns de cortesia: saudações e despedidas; apresentações; dizer por favor, obrigado, desculpe, etc.",
                "Escrever uma mensagem ou cartão postal curto e simples, por exemplo, enviando cumprimentos de férias.",
                "Preencher formulários com informações pessoais, por exemplo, inserir nome, nacionalidade e endereço em um formulário de registro de hotel.",
                "Escrever frases e sentenças simples e isoladas e poder escrever um cartão postal simples. Eles podem escrever cartas e mensagens curtas com a ajuda de um dicionário.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparação para o exame",
            },
            {
              type: "p",
              class: "",
              text: "Não há exame de saída associado ao nível Pré A1. Não espera-se que os alunos passem mais de 11 semanas neste nível. Ao progredir para o nível A1, eles se tornarão elegíveis para o Teste de Inglês Interativo.",
            },
          ],
        },
        '{"title": "A1 - A2 | Elementar",\n"tag": "TIE",\n"body": [\n    {"type": "p", "class": "text-blue2", "text": "Esboço do curso e objetivos"},\n    {"type": "p", "class": "", "text": "O curso de inglês geral A1 é destinado a alunos que vêm para a NED C com uma familiaridade básica com o inglês e que podem ter tido alguma experiência informal no aprendizado do inglês e contato com o idioma em um ambiente educacional, social ou recreativo. Esse pode não ser o primeiro curso de estudo recente do aluno. No entanto, como mencionado acima, cada curso é estruturado para permitir que o aluno permaneça no nível designado pelo tempo que for necessário, até a duração de 25 semanas. Durante um período de vinte e cinco semanas, espera-se que os alunos cubram as áreas de linguagem abaixo:"},\n    {"type": "p", "class": "text-green1", "text": "Os seguintes resultados de aprendizagem são atribuídos ao curso A1 (elementar), ao final do qual os alunos serão capazes de:"},\n    {"type": "p", "class": "text-green1", "text": "Habilidades receptivas"},\n    {"type": "ul", "list": ["Compreender a fala clara, lenta e padrão relacionada a áreas de relevância pessoal imediata (por exemplo, informações pessoais e familiares muito básicas, compras, geografia local e emprego)","Captar a ideia principal em mensagens e anúncios curtos, claros e simples.","Compreender textos curtos e simples contendo vocabulário de alta frequência e expressões internacionais compartilhadas.","Encontrar informações específicas e previsíveis em materiais simples do dia a dia, como anúncios, prospectos e horários.","Compreender placas e avisos diários em lugares públicos, como ruas, restaurantes, estações ferroviárias e locais de trabalho."]},\n    {"type": "p", "class": "text-green1", "text": "Habilidades produtivas"},\n    {"type": "ul", "list": ["Comunicar-se em tarefas simples e rotineiras, exigindo uma troca simples e direta de informações sobre tópicos e atividades familiares.","Lidar com trocas sociais muito breves, embora geralmente não consigam manter a conversa por conta própria.","Ter vocabulário suficiente para a expressão de necessidades comunicativas básicas e para lidar com necessidades de sobrevivência simples.","Usar algumas estruturas simples corretamente, mas ainda cometer erros básicos de forma sistemática, como confusão de tempos verbais e esquecimento de marcar concordância.","Dar descrições curtas e básicas de eventos e atividades e ser capaz de escrever cartas pessoais muito simples expressando agradecimentos e desculpas.","Escrever notas e mensagens curtas e simples relacionadas a assuntos do cotidiano.","Descrever planos e acordos e ser capaz de explicar o que gostam ou não gostam de algo.","Descrever sua família, condições de vida, escolaridade, emprego atual ou mais recente e ser capaz de descrever atividades passadas e experiências pessoais."]},\n    ],\n"footer": [\n    {"type": "p", "class": "fw-bold text-blue2", "text": "Preparação para exames"},\n    {"type": "p", "class": "", "text": "O exame no final desse nível, para alunos que terminam seu curso de aprendizado no nível A1 ou que avançaram e não completaram o número suficiente de semanas no nível A2, é o Teste de Inglês Interativo (TIE). Suporte discreto e aulas extras são oferecidos aos alunos a quem isso se aplica. Não há conteúdo específico do exame contido neste programa de estudos ou esquema de trabalho para este exame. No entanto, os componentes do exame dependem das habilidades aprendidas por meio da aplicação do programa de 25 semanas estabelecido nas áreas de leitura, escrita, fala e audição. O coordenador de exames do NED C será responsável por oferecer suporte individual ou em pequenos grupos para os alunos do nível A1 que estejam inscritos para fazer esse exame."}\n    ]}',
        {
          title: "A2 - B1 | Pré-Intermediário",
          tag: "TIE ou Trinity ISE Foundation",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Esboço e objetivos do curso",
            },
            {
              type: "p",
              class: "",
              text: "Esboço do curso de inglês geral Nível A2 (pré-intermediário) e objetivos O curso de inglês geral A2 é para alunos que começaram a consolidar a compreensão das habilidades elementares em inglês, mas ainda não apresentam a variedade de competências, em todas as quatro áreas de habilidades, que os levariam a se sentirem à vontade ou confiantes no nível intermediário. Os alunos podem interagir de maneira simples, mas trabalharão para expandir sua gama de estruturas gramaticais e vocabulário para uso diário em uma variedade de contextos, autodivulgação e confiança. Durante o período de vinte e cinco semanas, espera-se que os alunos cubram as áreas de linguagem abaixo:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Os seguintes resultados de aprendizagem são atribuídos ao curso A2 (pré-intermediário), nos quais os alunos serão capazes de fazer até o final:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades receptivas",
            },
            {
              type: "ul",
              list: [
                "Usar estruturas ligeiramente mais complexas do que no nível elementar corretamente, mas ainda cometer erros básicos de forma sistemática, como confusão de tempos verbais e esquecimento de concordância.",
                "Compreender a fala clara, lenta e padrão relacionada a áreas de interesse pessoal imediato (por exemplo, informações pessoais e familiares muito básicas, compras, geografia local e emprego)",
                "Captar o ponto principal em mensagens e anúncios curtos, claros e simples.",
                "Compreender textos curtos e simples contendo vocabulário de alta frequência e expressões internacionais comuns.",
                "Encontrar informações específicas e previsíveis em materiais simples do dia a dia, como anúncios, prospectos e horários.",
                "Compreender sinais e avisos cotidianos em locais públicos, como ruas, restaurantes, estações de trem e locais de trabalho",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Produtivas",
            },
            {
              type: "ul",
              list: [
                "Comunicar-se em tarefas simples e rotineiras que exijam uma troca simples e direta de informações sobre assuntos familiares e rotineiros.",
                "Descrever em termos simples aspectos de seu contexto, ambiente imediato e assuntos em áreas de necessidade imediata.",
                "Manter trocas sociais breves, sendo capaz de estender a conversa por si mesmos (usando question tags/perguntas de acompanhamento)",
                "Ter vocabulário suficiente para realizar tarefas diárias no supermercado/banco etc.",
                "Dar descrições estendidas de eventos e atividades e saber escrever cartas pessoais muito simples expressando agradecimentos, solicitações e desculpas.",
                "Escrever notas e mensagens curtas e simples relacionadas a assuntos da vida cotidiana.",
                "Descrever planos e arranjos e saber explicar o que gosta ou não gosta de algo.",
                "Descrever sua família, condições de vida, educação, trabalho atual ou mais recente e ser capaz de descrever atividades passadas e experiências pessoais.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparação para o exame",
            },
            {
              type: "p",
              class: "",
              text: "No nível A2, o exame de saída designado é o Trinity English. Incorporado ao plano de trabalho para o nível A2 estão exercícios de prática do tipo esperado no exame. O conteúdo de inglês geral do curso é considerado suficiente para preparar os alunos para o idioma necessário para passar no exame, mas exercícios extras estão incluídos no plano de trabalho para que os professores familiarizem os alunos com a forma do teste. Apoio adicional e discreto será oferecido pelo coordenador do exame C do NED.",
            },
          ],
        },
        {
          title: "B1 - B2 | Intermediário",
          tag: "B1 Preliminar",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Esboço do Curso e Objetivos",
            },
            {
              type: "p",
              class: "",
              text: "O curso B1 é voltado para alunos que começaram a consolidar e implementar sua compreensão das estruturas gramaticais em inglês e buscam desenvolver um vocabulário mais amplo, com ênfase na pronúncia e fluência em inglês falado e escrito. Ao longo de vinte e cinco semanas, espera-se que os alunos cubram as seguintes áreas da língua:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Os seguintes objetivos de aprendizado são atribuídos ao curso B1 (intermediário), ao final do qual os alunos serão capazes de:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Receptivas",
            },
            {
              type: "ul",
              list: [
                "Compreender textos simples sobre assuntos relacionados aos seus campos de interesse",
                "Encontrar e compreender informações gerais de que precisam em materiais do dia-a-dia, como cartas, folhetos e documentos oficiais curtos",
                "Procurar por um texto longo ou vários textos curtos para localizar informações específicas que precisam para ajudá-los a concluir uma tarefa",
                "Compreender os principais pontos de um discurso padrão claro sobre assuntos familiares encontrados regularmente no trabalho, na escola, no lazer, etc.",
                "Compreender o ponto principal de muitos programas de rádio ou TV sobre assuntos atuais ou de interesse pessoal ou profissional, quando a entrega for relativamente lenta e clara",
                "Adivinhar o significado de palavras desconhecidas ocasionais a partir do contexto e entender o significado das frases",
                "Geralmente acompanhar os pontos principais de uma discussão mais longa",
                "Compreender uma conversa em inglês claro no cotidiano, embora em situações da vida real, às vezes precisem pedir repetição de palavras e frases específicas",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Produtivas",
            },
            {
              type: "ul",
              list: [
                "Iniciar, manter e encerrar conversas simples cara a cara sobre tópicos que sejam familiares ou de interesse pessoal",
                "Participar de conversas não preparadas sobre tópicos que sejam familiares, de interesse pessoal ou relevantes para a vida cotidiana (por exemplo: família, hobbies, trabalho, viagens e eventos atuais)",
                "Usar os conectores mais frequentes para ligar frases simples e contar uma história ou descrever algo",
                "Dar breves razões e explicações para opiniões e planos",
                "Narrar uma história ou contar o enredo de um livro ou filme e descrever reações",
                "Escrever relatórios muito breves, que transmitam informações factuais de rotina e declarem razões para ações, escrever cartas pessoais descrevendo experiências, sentimentos e eventos em detalhes",
                "Descrever detalhes básicos de ocorrências imprevisíveis, por exemplo, um acidente",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparação para Exame",
            },
            {
              type: "p",
              class: "",
              text: "No nível B1, o exame oficial é o Cambridge B1 Preliminary. No esquema de trabalho para o nível B1, estão incluídos testes práticos nas áreas de habilidades examinadas pela Cambridge. Esses testes aparecem a cada duas semanas no esquema de trabalho. O curso como um todo contém quatro provas de prática completas, divididas por áreas de habilidades para uma análise mais detalhada. Dessa forma, os professores podem familiarizar os alunos com a natureza das provas de leitura, escrita, compreensão auditiva e expressão oral que eles farão ao final do curso. Mais provas de prática e exercícios serão oferecidos aos alunos conforme se aproximam do final do curso pelo coordenador do exame NED C.",
            },
          ],
        },
        {
          title: "B2 - C1 | Intermediário superior",
          tag: "B2 First ou IELTS",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Programa e objetivos",
            },
            {
              type: "p",
              class: "",
              text: "O curso de Inglês Geral B2 é para estudantes que possuem boa habilidade de comunicação e competência em todas as quatro áreas de habilidades, mas que precisam melhorar a fluência e a implementação de estruturas gramaticais mais complexas. Eles buscarão melhorar a compreensão de tópicos concretos e abstratos e produzir inglês falado e escrito sobre uma ampla gama de assuntos com o mínimo de necessidade de correção e permissão de interlocutores nativos. Ao longo do período de vinte e cinco semanas, espera-se que os estudantes cubram as seguintes áreas de linguagem:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Os seguintes resultados de aprendizagem são atribuídos ao curso B2 (intermediário superior), nos quais os estudantes serão capazes de:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Receptivas",
            },
            {
              type: "ul",
              list: [
                "Ler correspondência relacionada às suas áreas de interesse e entender facilmente o significado essencial.",
                "Entender artigos especializados fora de sua área, desde que possam usar um dicionário para confirmar terminologia.",
                "Ler vários tipos de textos facilmente em diferentes velocidades e de diferentes maneiras, de acordo com o propósito da leitura e o tipo de texto.",
                "Ter um amplo vocabulário de leitura, mas às vezes ter dificuldade com palavras e frases menos comuns.",
                "Identificar rapidamente o conteúdo e a relevância de notícias, artigos e relatórios sobre uma ampla gama de tópicos profissionais, decidindo se vale a pena um estudo mais aprofundado.",
                "Entender artigos e relatórios que tratam de problemas contemporâneos nos quais os escritores adotam posturas ou pontos de vista específicos.",
                "Entender discursos padronizados falados em uma velocidade normal e acompanhar mesmo linhas de argumentação complexas, desde que o tópico seja razoavelmente familiar.",
                "Entender o essencial de palestras e da maioria das notícias e programas de atualidades da televisão e ser capaz de entender a maioria dos filmes no dialeto padrão.",
                "Compreender conceitos onde apenas ruído de fundo extremo, estrutura pouco clara e/ou uso idiomático causam alguns problemas.",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Produtivas",
            },
            {
              type: "ul",
              list: [
                "Interagir com um grau de fluência e espontaneidade que torna a interação regular com falantes nativos bastante possível.",
                "Participar ativamente de discussões em contextos familiares e saber explicar e sustentar opiniões de forma clara, fornecendo explicações e argumentos relevantes.",
                "Apresentar descrições claras e detalhadas sobre uma ampla gama de assuntos relacionados à sua área de interesse, expandindo e apoiando ideias com pontos subsidiários e exemplos relevantes.",
                "Explicar um ponto de vista sobre um assunto atual fornecendo as vantagens e desvantagens de várias opções.",
                "Escrever textos claros e detalhados sobre uma ampla gama de assuntos relacionados aos seus interesses. Escrever um ensaio/ resenha/ artigo ou relatório, transmitindo informações ou fornecendo razões em apoio ou contra um determinado ponto de vista.",
                "Escrever cartas/e-mails destacando a importância pessoal de eventos e experiências.",
                "Sintetizar informações e argumentos de várias fontes.",
                "Construir uma sequência de argumento lógico e especular sobre causas, consequências e situações hipotéticas.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparação para o exame",
            },
            {
              type: "p",
              class: "",
              text: "No nível B2, o exame de saída designado é o Cambridge B2 First. O programa de 25 semanas é estruturado para fornecer prática e análise de questões do exame Cambridge B2 First, contextualizadas e dentro do framework de um curso de inglês geral. Há oito semanas completas de exercícios, atividades e prática no estilo Cambridge, intercaladas a cada três semanas durante o programa. A semana 25 do curso é dedicada exclusivamente ao exame de Cambridge, com os alunos trabalhando em exemplos de provas anteriores. Ao longo do curso, os estudantes se familiarizarão com o tipo de perguntas, atividades e linguagem que serão testados. Isso compõe cerca de um terço do conteúdo total de um curso geral, que se concentra na eficiência e eficácia da comunicação. Mais provas de prática e exercícios serão oferecidos aos estudantes quando eles estiverem se aproximando do final de seu curso pelo coordenador do exame C do NED.",
            },
          ],
        },
        {
          title: "C1 - C2 | Avançado",
          tag: "C1 Avançado ou IELTS",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Estrutura do curso e objetivos",
            },
            {
              type: "p",
              class: "",
              text: "O curso de Inglês Avançado C1 é para estudantes que possuem um sólido conhecimento das estruturas gramaticais e podem usar o inglês de forma flexível, tanto na escrita quanto na fala. Os alunos têm como objetivo expandir seu vocabulário e compreensão do inglês como é usado em vários contextos educacionais, profissionais e sociais, a fim de aumentar sua eficiência comunicativa com o mínimo de reparos e de busca por expressões.",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Os seguintes resultados de aprendizagem são atribuídos ao curso C1 (avançado), pelos quais os alunos serão capazes de:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Receptivas",
            },
            {
              type: "ul",
              list: [
                "Compreender qualquer correspondência com uso ocasional do dicionário.",
                "Entender em detalhes instruções longas e complexas sobre uma nova máquina ou procedimento, mesmo fora de sua área de especialização se puderem reler seções difíceis.",
                "Acompanhar uma conversa animada entre falantes nativos e entender o suficiente para acompanhar um discurso prolongado sobre tópicos abstratos e complexos além de sua própria área.",
                "Reconhecer uma ampla gama de expressões idiomáticas e coloquialismos e reconhecer mudanças de estilo.",
                "Acompanhar discursos longos, mesmo quando não estão claramente estruturados e quando as relações entre as ideias são apenas implícitas e não declaradas explicitamente.",
                "Acompanhar a maioria das palestras, discussões e debates com relativa facilidade e ser capaz de extrair informações específicas de anúncios públicos de baixa qualidade.",
                "Compreender informações técnicas complexas, como instruções de operação, especificações de produtos e serviços familiares.",
                "Compreender uma ampla variedade de materiais de áudio gravados, incluindo linguagem não padrão, e identificar pontos finos de detalhe, incluindo atitudes implícitas e relacionamentos entre os falantes.",
                "Acompanhar filmes que contenham um grau considerável de gírias e uso idiomático",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Produtivas",
            },
            {
              type: "ul",
              list: [
                "Apresentar descrições claras e detalhadas de assuntos complexos, integrando subtemas, desenvolvendo pontos específicos e concluindo de forma adequada.",
                "Comunicar-se espontaneamente, mostrando frequentemente fluência notável e facilidade de expressão, mesmo em trechos mais longos e complexos de fala.",
                "Selecionar uma formulação apropriada de uma ampla variedade de palavras para se expressar de forma clara, sem ter que restringir o que desejam dizer.",
                "Ter um bom domínio de um amplo repertório lexical, permitindo que lacunas sejam facilmente superadas com circunlóquios; pouca busca óbvia por expressões ou estratégias de evitação.",
                "Ter um bom domínio de expressões idiomáticas e coloquialismos, com occasional deslizes menores, mas sem erros significativos de vocabulário.",
                "Manter consistentemente um alto grau de precisão gramatical; os erros são raros e difíceis de identificar.",
                "Variar a entonação e colocar o estresse da frase corretamente para expressar nuances de significado.",
                "Usar a linguagem de forma flexível e eficaz para fins sociais, incluindo uso emocional, alusivo e engraçado.",
                "Escrever um texto claro e bem estruturado e expressar pontos de vista de forma detalhada.",
                "Escrever exposições detalhadas de assuntos complexos em uma carta, um ensaio ou um relatório, destacando as questões relevantes.",
                "Escrever diferentes tipos de textos em um estilo adequado ao leitor em questão.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparação para o exame",
            },
            {
              type: "p",
              text: "No nível C1, o exame de saída designado é o C1 Advanced. O programa de 25 semanas é estruturado para fornecer prática e análise de questões de exames de Cambridge no contexto e no âmbito de um curso de inglês geral. São oferecidas oito semanas completas de exercícios, atividades e práticas no estilo Cambridge, intercaladas a cada três semanas no programa. A semana 25 do curso é dedicada exclusivamente ao exame de Cambridge, com os alunos trabalhando em exemplos de provas anteriores.",
            },
            {
              type: "p",
              text: "Ao longo do curso, os alunos se familiarizarão com o tipo de perguntas, atividades e linguagem que serão testados. Isso representa cerca de um terço do conteúdo total de um curso geral que enfoca a eficiência e a eficácia comunicativa. Mais provas e exercícios de prática serão oferecidos aos alunos à medida que se aproximam do final do curso pelo coordenador do exame C da NED",
            },
          ],
        },
      ],
      button: "Fale com nossos agentes!",
    },
    section3: {
      title: "Fim de provas de curso",
      text: "Nossos professores incentivam e preparam os alunos para fazer provas no final do seu curso. Essas provas possuem reconhecimento global e vão impulsionar o seu perfil profissional.",
    },
  },
  accreditations: {
    title: "Padrões de alta qualidade procurados pelos nossos estudantes",
    breadcr: ["Sobre Nós", ">", "Associados e Acreditações"],
    section: {
      title1:
        "A NED College tem orgulho de estar associada a grandes instituições para garantir os padrões de alta qualidade procurados pelos nossos estudantes. Essas acreditações contribuem para a proteção do consumidor e garantem que todos os nossos serviços atendam aos requisitos exigidos por lei.",
    },
    items: [
      {
        logo: "logo_eaquals",
        title: "EAQUALS - Excelência em Educação em Idiomas",
        body: "A NED College foi inspecionada pela Eaquals em 2023, uma organização internacionalmente reconhecida focada em garantir a excelência em educação em idiomas, e atendeu aos altos padrões exigidos para a acreditação da Eaquals. O ensino, os programas dos cursos, assim como a organização dos cursos, os recursos de aprendizagem, os testes e a avaliação foram considerados de alta qualidade. Foi constatado que a instituição se preocupa muito com o bem-estar de seus clientes e funcionários, e todos os materiais publicitários produzidos pela instituição são precisos e verdadeiros. Com a acreditação da EAQUALS, você pode ter confiança em escolher a NED College para uma jornada educacional superior.",
      },
      {
        logo: "logo_asic",
        title:
          "ASIC - Serviço de Acreditação para Escolas, Faculdades e Universidades Internacionais",
        body: "Esta organização inspeciona instituições educacionais internacionalmente e seu principal objetivo é garantir que o conteúdo, os programas e a garantia de qualidade da instituição atendam a todos os requisitos regulatórios. A acreditação é uma confirmação de que a escola foi avaliada e atende a altos padrões de educação e boas práticas. Assim, você tem a garantia de uma experiência de aprendizado positiva.",
      },
      {
        logo: "logo_ilep",
        title: "Lista Provisória de Programas Elegíveis do ILEP",
        body: "Esta foi implementada pelo Departamento de Justiça e Igualdade em 20 de janeiro de 2016. Apenas as escolas que estão na lista podem receber estudantes não europeus para cursos de longa duração. A NED College está na lista provisória de escolas.",
      },
      {
        logo: "logo_progressive",
        title: "PCN Progressive College Network",
        body: "A Progressive College Network é uma organização formada para atender à demanda por uma entidade representativa alternativa para a comunidade de faculdades particulares na Irlanda.",
      },
      {
        logo: "logo_academy_plus",
        title: "Corretores de Seguros da Academy Plus - Proteção ao Estudante",
        body: "De acordo com as regulamentações nacionais vigentes, todos os estudantes matriculados em cursos com duração de 3 meses ou mais são obrigados a adquirir a Proteção ao Estudante como parte das taxas do curso. Este é um seguro que protege as taxas do estudante em caso de algo acontecer com a escola.",
      },
      {
        logo: "logo_cambridge",
        title: "Exames ESOL da Universidade de Cambridge",
        body: "A Universidade de Cambridge oferece a gama mais reconhecida mundialmente de qualificações em inglês na forma de exames ESOL de Cambridge. Sua rede abrangente inclui mais de 2.700 centros e 20.000 examinadores. A NED College oferece preparação para exames de Cambridge, os quais podem ser realizados em nosso centro de exames de Cambridge localizado na UL.",
      },
      {
        logo: "logo_ielts",
        title: "IELTS",
        body: "O International English Language Testing System é um teste padronizado internacional de proficiência em língua inglesa para falantes não nativos da língua inglesa. É gerenciado conjuntamente pelo British Council, IDP: IELTS Australia e Cambridge Assessment English, e foi estabelecido em 1989.",
      },
      {
        logo: "logo_lap",
        title: "Proteção ao Estudante da Academy - Matricula Efetuada",
        body: "De acordo com as regulamentações nacionais vigentes, todos os estudantes matriculados em cursos com duração de 3 meses ou mais são obrigados a adquirir a Proteção ao Estudante como parte das taxas do curso. Este é um seguro que protege as taxas do estudante em caso de algo acontecer com a escola.",
      },
      {
        logo: "logo_tie",
        title: "TIE",
        body: "TIE é uma qualificação moderna, inovadora e amigável de ESOL disponível internacionalmente. Concedido pela Gatehouse Awards, o TIE foi desenvolvido para candidatos que não são falantes nativos da língua inglesa. Seu objetivo é permitir que os candidatos desenvolvam suas habilidades de Fala, Compreensão Auditiva, Leitura e Escrita em todos os níveis do CEFR (A1 a C2), ajudando-os a se preparar para o ensino superior ou emprego profissional.",
      },
    ],
  },
  campus_dublin: {
    title: "Campus de Dublin",
    breadcr: ["Nossos campus", ">", "Dublin"],
    section1: {
      title:
        "Dublin é a capital da Irlanda, uma cidade cosmopolita e vibrante que pode ser tão acolhedora quanto um\n            pub irlandês.",
      text: "Originalmente fundada pelos vikings, esta cidade, cercada por montanhas e mar, tem de tudo.\n            Com sua combinação impecável de monumentos clássicos, uma excelente atmosfera e\n            vida noturna, inúmeras atividades de lazer e áreas verdes para passear, Dublin se tornou\n            um dos destinos mais populares para estudantes internacionais viverem uma\n            grande aventura no exterior.",
    },
    section2: {
      text: "Dublin tem sido a casa do",
      text1: "NED College há mais de 10 anos.",
      text2:
        "Durante esse período, crescemos e nos expandimos para proporcionar tudo que um estudante precisa para aprender o idioma mais importante do mundo.",
    },
    section3: {
      title: "Campus de Dublin",
      text1:
        "O Campus de Dublin do NED College possui 2 prédios construídos em 1750 - todos localizados no coração da cidade,\n            acessados por diversos serviços de transporte público ou a pé.",
      text2:
        "Em nosso campus de Dublin, estamos comprometidos em proporcionar um ambiente confortável e de apoio\n            para nossos estudantes multiculturais e aprimorar a experiência do estudante, tornando\n            um local ideal para estudar e crescer.",
    },
    section4: {
      cards: [
        {
          icon: "girl",
          title: "Recepção",
          body: "Área de recepção, onde nossos simpáticos recepcionistas ajudam os estudantes com suas perguntas.",
        },
        {
          icon: "cuttlery",
          title: "Refeitório",
          body: "Lindo refeitório que oferece aos nossos estudantes uma variedade de bebidas quentes, refrigerantes e opções de comida.",
        },
        {
          icon: "classroom",
          title: "Salas de aula",
          body: "Outro recurso-chave de nosso campus são as salas de aula modernas e totalmente equipadas.",
        },
        {
          icon: "building",
          title: "2 prédios",
          body: "Infraestrutura com 2 prédios para apoiar e aprimorar a experiência do estudante, tornando-o um local ideal para estudar e crescer.",
        },
        {
          icon: "sofa",
          title: "Sala de estar",
          body: "Também temos uma sala de estar com uma biblioteca, onde os estudantes podem se reunir para relaxar, conversar, estudar ou fazer novos amigos.",
        },
      ],
    },
    section5: {
      title: "DÊ UMA OLHADA EM NOSSOS PRÉDIOS",
      button: "Quero estudar aqui",
    },
    section6: {
      title: "O Que Você Pode Encontrar Próximo ao Campus de Dublin do NED College",
      text1: "Paradas para o principal",
      text2: "transporte público",
      text3: "na cidade",
      text4: "Principais",
      text5: "atrações turísticas e monumentos",
      text6: "Centros comerciais, lojas e",
      text7: "diferentes tipos de restaurantes",
    },
    testimonialsection: {
      title: "Confira o que nossos estudantes estão dizendo sobre o NED College",
    },
    mapsection: {
      title: "Uma mistura de nacionalidades",
      body: "Todo mês, no NED College, recebemos estudantes de todo o mundo. Para lhe oferecer um serviço melhor e personalizado,",
      body1:
        "oferecemos suporte aos estudantes em seu próprio idioma antes da chegada e durante o período de estudo na Irlanda.",
    },
    section7: {
      title1: "Conheça nossos prédios do Campus de Dublin",
      title2: "O que você está esperando?",
      button: "Escolha o campus de Dublin",
    },
  },
  campus_limerick: {
    title: "Campus de Limerick",
    breadcr: ["Nossos Campi", ">", "Limerick"],
    section1: {
      title:
        "Originalmente fundada pelos Vikings, Limerick é uma cidade tradicional, onde é possível vivenciar a autêntica cultura irlandesa.",
      text: "Limerick está localizada no Midwest da Irlanda e possui 191.000 habitantes, tornando-se a terceira maior cidade do país. Sempre há algo para fazer na cidade de Limerick, pois há muitos locais históricos fascinantes, pubs antigos, áreas comerciais, eventos culturais, restaurantes deliciosos e excelente transporte público. Por isso, Limerick é o lugar perfeito para aprender inglês, aproveitando a qualidade de vida e os baixos custos que a cidade oferece em comparação com o resto do país.",
    },
    section2: {
      text: "Em 2019, abrimos nossa nova escola nesta cidade",
      text1:
        " e tem sido um sucesso completo! Desde então, recebemos centenas de alunos de diferentes países e mais estão chegando a cada mês!",
    },
    section3: {
      title: "Campus de Limerick",
      text: "O Campus de Limerick da NED College está localizado no coração da cidade, oferecendo instalações totalmente novas e modernas para os alunos. Assim como em Dublin, em nosso campus de Limerick, estamos comprometidos em oferecer um ambiente de apoio e confortável para nossos alunos multiculturais.",
    },
    section4: {
      cards: [
        {
          icon: "girl",
          title: "Recepção",
          body: "Área de recepção, onde nossos recepcionistas amigáveis auxiliam os alunos com suas perguntas.",
        },
        {
          icon: "cuttlery",
          title: "Cantina",
          body: "Cantina linda que oferece aos nossos alunos uma variedade de bebidas quentes, bebidas não alcoólicas e opções de comida.",
        },
        {
          icon: "classroom",
          title: "Salas de aula",
          body: "Outra característica importante de nosso campus são as salas de aula modernas e completamente equipadas.",
        },
        {
          icon: "building",
          title: "1 edifício",
          body: "Infraestrutura de 1 edifício para apoiar e aprimorar a experiência do aluno, tornando-o um lugar ideal para estudar e crescer.",
        },
        {
          icon: "sofa",
          title: "Área de estar",
          body: "Temos também uma área de estar com biblioteca, onde os alunos podem se reunir para relaxar, conversar, estudar ou fazer novos amigos.",
        },
        {
          icon: "disabled",
          title: "Banheiro para deficientes",
          body: "Banheiros para deficientes limpos e modernos.",
        },
      ],
    },
    section5: {
      title: "Dê uma olhada em nosso Campus de Limerick",
      button: "Eu quero estudar aqui",
    },
    section6: {
      title: "O que há perto do Campus de Limerick da NED College",
      text1: "Pontos de ônibus para o transporte público principal",
      text2: "na cidade",
      text3: "Muitas atrações turísticas e monumentos",
      text4: "Centros de compras, lojas,",
      text5: "muitos tipos diferentes de restaurantes",
      text6: "e espaços culturais",
    },
    testimonialsection: {
      title: "Confira o que nossos alunos estão dizendo sobre a NED College",
    },
    mapsection: {
      title: "Uma mistura de nacionalidades",
      body: "Todo mês, na NED College, recebemos alunos de todo o mundo. Para oferecer um serviço melhor e personalizado,",
      body1:
        "oferecemos suporte aos estudantes em seu próprio idioma antes da chegada e durante o período de estudo na Irlanda.",
    },
    section7: {
      title1: "Conheça nosso Campus de Limerick",
      title2: "O que você está esperando?",
      button: "Escolha o campus de Limerick",
    },
  },
  contact_us: {
    title: "Entre em contato",
    breadcr: ["Contate-nos"],
    section1: {
      title:
        "Vamos lá! Dê o primeiro passo para estudar inglês na Irlanda! Estamos aqui para responder todas as suas perguntas.",
    },
    section3: {
      title1: "Conheça nossas localizações",
      title2: "Campus de Dublin",
    },
    section4: {
      title: "Campus de Limerick",
    },
  },
  faqs: {
    title: "Perguntas Frequentes",
    breadcr: ["Perguntas frequentes"],
    section1: {
      title: "Sabemos que se preparar para viajar para o exterior não é fácil.",
      text: "É por isso que preparamos estas perguntas frequentes especiais para ajudá-lo a entender melhor tudo que você precisa saber sobre estudar inglês e trabalhar na Irlanda.",
    },
    sections: [
      {
        title: "Antes de viajar para a Irlanda",
        items: [
          {
            title: "Por que estudar no exterior?",
            body: [
              {
                type: "p",
                class: "",
                text: "Estudar no exterior é um sonho perseguido por muitos jovens e, mais recentemente, por pessoas de todas\n                as idades. A decisão de estudar no exterior deve ser tomada sozinha. Pergunte a si mesmo qual motivação você tem\n                para perseguir esse sonho. Embora suas motivações sejam pessoais e seja totalmente você\n                para se decidir sobre isso, estudos têm mostrado que pessoas que estudaram no exterior\n                melhoraram não apenas suas habilidades linguísticas, mas também aumentaram sua confiança, autoestima e\n                capacidade de resolver problemas e lidar com pressão. Para saber mais sobre isso, dê uma olhada\n                nesse estudo:",
              },
              {
                type: "a",
                class: "",
                link: "https://www.iesabroad.org/study-abroad/benefits",
                text: "https://www.iesabroad.org/study-abroad/benefits",
              },
            ],
          },
          {
            title: "Por que estudar na Irlanda?",
            body: [
              {
                type: "p",
                class: "",
                text: "A Irlanda está se tornando cada vez mais popular entre estudantes de todo o mundo, pois suas leis de imigração são consideradas flexíveis e abertas para estudantes não europeus. Os estudantes podem vir para estudos de curto ou longo prazo, neste último caso é possível trabalhar enquanto estuda no país. É um processo bastante simples se aplicar para o visto, pois ocorre após a chegada do estudante no país. Além dos motivos acima, a Irlanda é um país lindo e muito histórico, oferecendo várias atividades culturais e a oportunidade de conhecer pessoas de todos os lugares. Não é preciso dizer que a Irlanda está muito bem localizada e oferece os voos mais baratos para outros países na Europa.",
              },
            ],
          },
          {
            title: "Onde estudar inglês na Irlanda?",
            body: [
              {
                type: "p",
                class: "",
                text: "Existem muitas cidades na Irlanda que oferecem oportunidades para aprender inglês e trabalhar. As favoritas são Dublin, Cork, Galway e Limerick. Na NED College, você pode escolher entre ",
              },
              {
                type: "a",
                class: "",
                link: "https://ned.ie/about/dublin",
                text: "Dublin",
              },
              {
                type: "p",
                class: "",
                text: "e",
              },
              {
                type: "a",
                class: "",
                link: "https://ned.ie/about/limerick",
                text: "Limerick",
              },
            ],
          },
          {
            title: "O que é um Cidadão Não Europeu?",
            body: [
              {
                type: "p",
                class: "",
                text: "Um não-cidadão da UE é uma pessoa que é originária de países que não fazem parte do acordo da UE. Os nacionais da UE têm a liberdade de se mudar para outro país da UE para trabalhar sem necessitar de um visto de trabalho. As únicas exceções a isso são as pessoas que vêm da Islândia, Liechtenstein e Noruega, pois seus cidadãos podem trabalhar na UE com os mesmos direitos dos nacionais da UE, já que pertencem à Área Econômica Europeia. Para verificar os direitos exatos em relação ao seu país de origem, acesse:",
              },
              {
                type: "a",
                class: "",
                link: "http://ec.europa.eu/social/main.jsp?catId=470&langId=pt",
                text: "http://ec.europa.eu/social/main.jsp?catId=470&langId=pt",
              },
            ],
          },
          {
            title: "Posso trabalhar e estudar na Irlanda como cidadão NÃO-europeu?",
            body: [
              {
                type: "p",
                class: "",
                text: "Sim. Isso é parte do que torna a Irlanda um destino tão atraente para o seu programa de estudos no exterior. Ao se matricular em um curso de longa duração, você tem permissão para trabalhar 20 horas por semana durante os horários regulares e 40 horas durante as férias de verão e Natal (as datas específicas são definidas pelas autoridades de imigração irlandesas). Detentores do visto Stamp 2 têm permissão para trabalhar em tempo integral de acordo com as disposições da legislação trabalhista durante os meses de junho, julho, agosto e setembro, e de 15 de dezembro a 15 de janeiro, inclusive. Em todos os outros momentos, eles estarão limitados a trabalhar 20 horas por semana. Saiba mais: ",
              },
              {
                type: "a",
                class: "",
                link: "http://www.inis.gov.ie/en/INIS/Pages/Frequently%20Asked%20Questions%20-%20Students",
                text: "http://www.inis.gov.ie/en/INIS/Pages/Frequently%20Asked%20Questions%20-%20Students",
              },
            ],
          },
          {
            title: "Posso trabalhar depois de estudar na Irlanda?",
            body: [
              {
                type: "p",
                class: "",
                text: "Se você não possui um passaporte europeu, só poderá trabalhar enquanto estuda na Irlanda. No entanto, ao concluir um nível de ensino superior (graduação, pós-graduação, mestrado ou doutorado), você pode obter um visto de trabalho válido por 1 a 2 anos.",
              },
            ],
          },
          {
            title: "O que devo estudar na Irlanda?",
            body: [
              {
                type: "p",
                text: "Você pode estudar qualquer curso que você tenha interesse, desde que tenha sido aceito por uma instituição irlandesa.\n     Há algumas observações quanto à possibilidade de trabalhar meio período na Irlanda, que é apenas permitido caso esteja matriculado em um curso de tempo integral. Os cursos que se enquadram nesta categoria são: Inglês como Língua Estrangeira, Diploma Nacional de Ensino Superior, Mestrado e Doutorado. Recomendamos que você comece seus estudos com um curso de língua inglesa, de preferência no NED College, pois estamos comprometidos em oferecer o melhor suporte para aumentar suas chances de ser aceito posteriormente em um curso de nível superior.",
              },
            ],
          },
          {
            title: "Qual é a idade mínima para fazer um programa de intercâmbio de estudantes?",
            body: [
              {
                type: "p",
                text: "Na NED College, ficamos felizes em receber estudantes que tenham 18 anos ou mais. Se você tiver menos de 18 anos, podemos aceitá-lo apenas para cursos de curta duração, de 1 a 12 semanas. Vistos de curta duração 'C' para crianças menores de 18 anos devem indicar se a criança está viajando sozinha (desacompanhada) ou com um adulto (acompanhada). Se a criança estiver acompanhada, a(s) pessoa(s) nomeada(s) no visto da criança deverá(ão) estar com ela durante toda a viagem. Caso contrário, a criança não poderá viajar. Para saber mais:",
              },
              {
                type: "a",
                link: "http://www.inis.gov.ie/en/INIS/Pages/visa-short-stay-children",
                text: "http://www.inis.gov.ie/en/INIS/Pages/visa-short-stay-children",
              },
            ],
          },
          {
            title: "O que é um Stamp 2?",
            body: [
              {
                type: "p",
                text: "É uma permissão para estudar na Irlanda. O Stamp 2 indica permissão para estudar um curso em tempo integral na lista oficial \n                ",
              },
              {
                type: "a",
                link: "https://www.irishimmigration.ie/coming-to-study-in-ireland/what-are-my-study-options/a-third-level-course-or-a-language-course/",
                text: "Interim List of Eligible Programmes (ILEP)",
              },
              {
                type: "p",
                text: "por um período específico, sujeito a condições. De acordo com a regulamentação irlandesa, o estudante precisa estar matriculado em um \n                dos seguintes cursos: Língua Inglesa, Diploma Nacional de Ensino Superior, Bacharelado, Mestrado \n                (pós-graduação), PhD. Para saber mais: ",
              },
              {
                type: "a",
                link: "http://www.inis.gov.ie/en/INIS/Pages/registration-stamps#stamp2",
                text: "http://www.inis.gov.ie/en/INIS/Pages/registration-stamps#stamp2",
              },
            ],
          },
          {
            title: "Preciso aplicar para um visto para estudar na Irlanda?",
            body: [
              {
                type: "p",
                text: "Isso dependerá do tempo que você pretende estudar na Irlanda e também do país de origem.\n                Para verificar se os cidadãos do seu país precisam de visto para entrar na Irlanda, clique neste link: ",
              },
              {
                type: "p",
                link: "http://www.inis.gov.ie/en/INIS/Pages/check-irish-visa",
                text: "http://www.inis.gov.ie/en/INIS/Pages/check-irish-visa",
              },
              {
                type: "p",
                text: "Geralmente, para estudar na Irlanda por menos de 3 meses, você não precisará aplicar para visto. No entanto, se você pretende trabalhar enquanto estuda na Irlanda, será necessário aplicar para um visto assim que você chegar ao país. Essa regra se aplica apenas aos cidadãos não europeus. ",
              },
            ],
          },
          {
            title: "Tenho que reservar o meu curso de inglês antes do início da minha viagem?",
            body: [
              {
                type: "p",
                text: "Sim, você deve. Note que a carta da escola afirmando que você está matriculado em um curso de inglês é um dos documentos mais importantes que você deve apresentar ao atravessar a fronteira para a Irlanda. Este requisito se aplica tanto para cursos de curta duração quanto para cursos de longa duração. Mostrar que você está entrando no país por motivos educacionais será fundamental para o seu sucesso.",
              },
            ],
          },
          {
            title: "Quais documentos devo apresentar no controle de fronteira da Irlanda?",
            body: [
              {
                type: "p",
                text: "Quando chegar na Irlanda, você deverá apresentar seu passaporte (válido por pelo menos 6 meses e/ou pelo período que você pretende ficar no país, o que significa que se você reservou um curso de 8 meses, seu passaporte precisa ser válido pelos próximos 8 meses), <strong>a carta da escola, a carta de acomodação, comprovante de recursos financeiros (extrato do cartão ou dinheiro em espécie) e as passagens de volta impressas.</strong>",
              },
            ],
          },
          {
            title: "Qual é o nível de inglês exigido para estudar no exterior?",
            body: [
              {
                type: "p",
                text: "Se você está vindo para aprender inglês, não exigimos nenhum conhecimento da língua, pois oferecemos cursos de inglês a partir do nível mais elementar. No entanto, se você pretende estudar cursos de nível superior, será necessário comprovar um nível mais elevado, possivelmente até avançado, de inglês.",
              },
            ],
          },
          {
            title: "Com que antecedência devo reservar meu curso?",
            body: [
              {
                type: "p",
                text: "Depende da nossa disponibilidade. Você pode precisar de mais tempo para economizar dinheiro suficiente para vir para a Irlanda. No entanto, se você já decidiu e optou por vir imediatamente, faremos o possível para garantir um lugar em nossa escola. Além disso, recomendamos que você reserve seu curso com três meses de antecedência para garantir uma vaga, melhores promoções de voos, etc. Após reservar e pagar integralmente suas taxas, você precisará viajar para a Irlanda no próximo ano. Se esse período expirar, não poderemos mais acomodá-lo e você não terá direito a nenhum reembolso.",
              },
            ],
          },
          {
            title: "Posso trabalhar na Irlanda enquanto faço um curso de inglês de curta duração?",
            body: [
              {
                type: "p",
                text: "Não, você não pode. Você pode estudar na Irlanda fazendo um curso de curta ou longa duração. A diferença é que em um curso de curta duração você não tem permissão para trabalhar. No entanto, você pode mergulhar na cultura irlandesa enquanto está no país. Essa opção é recomendada para aqueles que não têm muito tempo para viajar para o exterior e estão dispostos a usar suas férias de trabalho para viajar e estudar.",
              },
            ],
          },
          {
            title: "Quais tipos de cursos me permitem trabalhar na Irlanda?",
            body: [
              {
                type: "p",
                text: "Para obter o Stamp 2, você precisa estar matriculado em um curso de longo prazo com duração mínima de 8 meses (programa de estudo e trabalho: curso de inglês de 6 meses + 2 meses de férias).",
              },
            ],
          },
          {
            title: "Quantas horas posso trabalhar na Irlanda?",
            body: [
              {
                type: "p",
                text: "Uma vez matriculado em um curso de inglês em tempo integral, você tem permissão para trabalhar na Irlanda por 20 horas por semana durante os meses regulares e até 40 horas durante os meses de verão e férias de Natal. Os portadores de visto Stamp 2 estão autorizados a trabalhar em tempo integral de acordo com as disposições da legislação trabalhista durante os meses de junho, julho, agosto e setembro e de 15 de dezembro a 15 de janeiro, inclusive. Em todos os outros momentos, eles estarão limitados a trabalhar 20 horas por semana.",
              },
            ],
          },
          {
            title: "Eu preciso de um seguro saúde?",
            body: [
              {
                type: "p",
                text: "Sim. Se você não é um cidadão europeu, será necessário ter um seguro de saúde privado. Com isso, você estará protegido em caso de emergências médicas enquanto estiver morando no exterior. O seguro é obrigatório para programas de longa duração. Ao reservar seu curso com o NED College, o seguro saúde será incluído no pacote, então você não precisará se preocupar com isso.",
              },
            ],
          },
          {
            title: "Qual é a melhor época do ano para viajar?",
            body: [
              {
                type: "p",
                text: "A melhor época é aquela que se encaixa nas suas próprias necessidades. Isso dependerá do estilo de vida de cada estudante.\n                No entanto, recomendamos o verão por várias razões: alguns estudantes estão voltando para casa, o que torna\n                o momento ideal para encontrar acomodação; empregos e fazer novos amigos, já que um novo grupo de pessoas está chegando\n                Para os estudantes que preferem o inverno, é melhor chegar nos meses entre outubro e abril,\n                para aqueles que preferem tempo quente, eles podem vir de abril a setembro. Se eles gostam de festas, podem vir\n                para o Dia de São Patrício em março ou para o Halloween em outubro. No geral, isso dependerá do seu gosto e objetivos.",
              },
            ],
          },
          {
            title: "A NED College vende passagens aéreas?",
            body: [
              {
                type: "p",
                text: "Não. Oferecemos suporte para ajudá-lo a encontrar as melhores opções e preços. Como estudante, você também pode aproveitar as taxas e condições especiais para estudantes. No entanto, é inteiramente responsabilidade dos estudantes reservarem suas passagens aéreas. No entanto, podemos ter uma parceria com algumas empresas de viagens, então você deve perguntar ao seu agente.",
              },
            ],
          },
          {
            title: "Eu preciso comprar uma passagem de volta?",
            body: [
              {
                type: "p",
                text: "Sim. É um requisito legal apresentar a passagem de volta ao chegar no controle de fronteira irlandês. Não ter a passagem de volta pode resultar em deportação.",
              },
            ],
          },
          {
            title: "Eu preciso tomar vacinas especiais antes da minha viagem?",
            body: [
              {
                type: "p",
                text: "Não. Não há exigência legal. No entanto, de acordo com o CDC (Centres for Disease Control and\n                  Prevention), todos os viajantes devem se certificar de que estão atualizados com as vacinas de rotina antes de qualquer viagem.\n                  A vacina recomendada antes da sua viagem é a Hepatite A. Para saber mais:",
              },
              {
                type: "a",
                link: "https://wwwnc.cdc.gov/travel/destinations/traveler/none/ireland",
                text: "https://wwwnc.cdc.gov/travel/destinations/traveler/none/ireland",
              },
            ],
          },
          {
            title: "Quanto dinheiro devo levar para a Irlanda?",
            body: [
              {
                type: "p",
                text: "Se a duração do seu curso for inferior a 6 meses, você deve ter acesso a €500 por mês da sua estadia ou €3000, o que for menor. (Após 01 de julho de 2023, será necessário apresentar evidências de que você tem acesso a pelo menos €700 por mês da sua estadia ou €4.200, o que for menor)",
              },
            ],
          },
          {
            title: "Como faço para marcar uma consulta no Irish Immigration?",
            body: [
              {
                type: "p",
                text: "Após sua chegada na Irlanda, sua primeira preocupação será solicitar seu visto de longa duração. Você irá recolher todos os documentos necessários em nossa escola, estes são: carta da escola, certificado de seguro de saúde, além do comprovante de recursos financeiros.",
              },
              {
                type: "p",
                text: "Se você escolheu Dublin, quando tiver todos os documentos, é necessário ligar para o número gratuito 1800 800 630 para marcar sua consulta. Se precisar de ajuda, peça ao seu consultor. Por favor, verifique o site de imigração para mais informações: ",
              },
              {
                type: "a",
                link: "https://www.irishimmigration.ie/burgh-quay-appointments",
                text: "https://www.irishimmigration.ie/burgh-quay-appointments",
              },
              {
                type: "p",
                text: "Se você escolheu Limerick, envie um email para limerick.registration@garda.ie para marcar uma consulta.\n                *Lembre-se de que só é possível marcar quando você estiver na Irlanda.",
              },
            ],
          },
          {
            title:
              "Como posso provar que tenho fundos suficientes para me sustentar durante minha estadia?",
            body: [
              {
                type: "p",
                class: "",
                text: "Você pode provar que possui fundos suficientes apresentando uma das opções abaixo:",
              },
              {
                type: "ul",
                list: [
                  {
                    title: "Prova de um banco irlandês",
                    text: "Se você optar por esta opção, é necessário apresentar um extrato original de um banco irlandês que mostre um saldo de €3.000",
                  },
                  {
                    title: "Prova de um banco estrangeiro",
                    text: "Se você optar por esta opção, é necessário apresentar 2 extratos bancários originais de um banco estrangeiro",
                  },
                  {
                    title: "Prova de uma empresa de serviços financeiros na Irlanda",
                    text: "Se você optar por esta opção, é necessário apresentar uma carta original de uma empresa de serviços financeiros na Irlanda que mostre que ela possui €3.000 'em custódia' para você",
                  },
                  {
                    title: "Prova via cartão de crédito pré-pago ou cartão de débito",
                    text: "Se você optar por esta opção, é necessário apresentar evidências que demonstrem ao escritório de registro que você possui cartões de crédito pré-pagos ou cartões de débito com €3.000",
                  },
                ],
              },
              {
                type: "p",
                text: "Para obter mais informações, consulte o site de Imigração: ",
              },
              {
                type: "a",
                link: "https://www.irishimmigration.ie/registering-your-immigration-permission/how-to-register-your-immigration-permission-for-the-first-time/requirements-and-documents-needed/",
                text: "https://www.irishimmigration.ie/registering-your-immigration-permission/how-to-register-your-immigration-permission-for-the-first-time/requirements-and-documents-needed/",
              },
            ],
          },
          {
            title: "O que é um cartão IRP ou GNIB?",
            body: [
              {
                type: "p",
                text: "O Cartão de Permissão de Residência da Irlanda (IRP) é um certificado de registro que comprova que você está autorizado a permanecer e trabalhar na Irlanda durante a sua estadia. Um IRP custa <strong>€300</strong> por pessoa a cada vez que você solicita um visto de estudante no país. Você pode permanecer na Irlanda por até 2 anos como estudante de inglês. Isso significa que toda vez que você renovar o seu curso, terá que pagar a taxa de €300 por um novo cartão IRP. GNIB é o antigo nome do cartão IRP. Tenha em mente que esse cartão é muito importante, pois, embora não sirva como método oficial de identificação, é necessário para fins de imigração toda vez que você sai ou entra no país, então recomendamos que você o mantenha em sua residência e não o carregue na rua.",
              },
            ],
          },
          {
            title: "Como faço para pagar o meu cartão IRP?",
            body: [
              {
                type: "p",
                text: "Pague com cartão de crédito ou débito no escritório de registro de Burgh Quay e em outros escritórios em todo o país.\nPara pagar usando cartão de crédito ou débito, traga seu cartão e use normalmente.",
              },
            ],
          },
        ],
      },
      '{"title":"Sobre nossa Escola","items":[{"title":"Quais cursos de inglês a NED College oferece?","body":[{"type":"p","text":"Oferecemos Cursos de Inglês Geral e IELTS, saiba mais aqui:"},{"type":"a","link":"https://ned.ie/courses/","text":"https://ned.ie/courses/"}]},{"title":"Por que devo escolher a NED College?","body":[{"type":"p","text":"Nossa escola moderna possui mais de 20 salas de aula totalmente equipadas em ambos os campi de Dublin e Limerick, projetadas para oferecer aos alunos um ambiente de aprendizado ideal em que eles possam prosperar e alcançar todo o seu potencial. Além disso, temos uma recepção acolhedora, uma cantina espaçosa e uma confortável sala de estudantes."}]},{"title":"Qual preparação para exames a NED College oferece?","body":[{"type":"p","text":"Preparamos nossos alunos para diferentes tipos de exames de inglês: TIE, Trinity Integrated Skills in English, ISE, IELTS e Cambridge. O exame de final de curso é obrigatório para todos os alunos que requerem visto, seguindo as regras do GNIB, e as taxas estão incluídas na maioria de nossos pacotes. Recomendamos que você verifique com seu agente para ter certeza de que também está incluído no seu."}]},{"title":"O que é o exame TIE?","body":[{"type":"p","text":"O Test of Interactive English (TIE) é um exame internacional de inglês para falantes de outras línguas desenvolvido na Irlanda por um grupo de profissionais de inglês irlandeses sob a égide do Conselho Consultivo de Escolas de Língua Inglesa (ACELS), uma agência do governo que era responsável na época pela garantia de qualidade no ensino de inglês como língua estrangeira. O TIE pode ser feito por estudantes juniores e adultos em cursos curtos ou longos na Irlanda e no exterior. Para saber mais: "},{"type":"a","link":"https://www.yesireland.ie/i-have-a-tie-exam-and-now/","text":"https://www.yesireland.ie/i-have-a-tie-exam-and-now/"}]},{"title":"O que é um exame Cambridge?","body":[{"type":"p","text":"Se você alcançou um nível avançado de inglês, isso significa que agora você está mais preparado para fazer exames de inglês mais avançados. Para isso, oferecemos aos nossos alunos a oportunidade de testar suas habilidades fazendo três tipos diferentes de exames Cambridge: PET, FCE e CAE. Para saber mais sobre cada um deles, clique aqui:"},{"type":"a","link":"https://www.yesireland.ie/cambridge-exams-pet-fce-and-cae-what-are-they/","text":"https://www.yesireland.ie/cambridge-exams-pet-fce-and-cae-what-are-they/"}]},{"title":"Eu preciso comparecer a 100% das aulas?","body":[{"type":"p","text":"Idealmente, sim, no entanto, muitos eventos inesperados podem acontecer e é improvável que você compareça a 100% das aulas. A taxa de presença mínima é de 85%. Como é um requisito legal, é importante ter em mente que não cumprir a presença de 85% pode levar à recusa se você tentar renovar seu visto no Escritório de Imigração da Irlanda."}]},{"title":"Posso ser expulso da NED College?","body":[{"type":"p","text":"Sim. Se um estudante não conseguir concluir seu curso com 85% de presença, a NED College se reserva o direito de expulsar o aluno sem emitir quatro avisos. A presença é um requisito do visto do estudante e a falta de comparecimento resultará em expulsão e pode resultar na perda da permissão do estudante para estudar e trabalhar na Irlanda. Em nossa comunidade, não toleramos qualquer forma de má conduta e a falta de adesão a isso pode levar à expulsão. Para saber mais, leia nossa Política Escolar aqui: "},{"type":"a","link":"https://ned.ie/about_us/privacy_policy/","text":"https://ned.ie/about_us/privacy_policy/"}]},{"title":"Processo de Recursos de Expulsão","body":[{"type":"p","text":"Em qualquer etapa do processo descrito acima, os alunos são bem-vindos e incentivados a discutir qualquer problema que possa estar contribuindo para sua incapacidade de cumprir os requisitos de presença. A escola tem uma política de portas abertas, vários funcionários disponíveis, bem como várias opções de comunicação abertas aos alunos. Se durante o processo descrito acima um aluno;"},{"type":"p","text":"(A) Não responder/interagir/engajar-se com a escola;"},{"type":"p","text":"(B) Continuar a não comparecer às aulas;"},{"type":"p","text":"(C) Se um aluno não conseguir atingir 85% de presença antes do final de seu curso - A NED College se reserva o direito de expulsá-lo sem emitir todos os avisos."}]},{"title":"Como sei meu nível de inglês?","body":[{"type":"p","text":"Assim que você reservar seu curso, receberá por e-mail um link para o teste de nivelamento, no qual será avaliado em sua gramática, leitura e escrita',
      {
        title: "Viver na Irlanda",
        items: [
          {
            title: "Onde encontrar acomodações permanentes?",
            body: [
              {
                type: "p",
                text: "Como a Irlanda é um país relativamente pequeno, encontrar acomodações não deve ser difícil, já que o país está preparado para receber estudantes de todos os lugares. A cidade de Dublin é dividida em 24 distritos postais diferentes: os números ímpares estão localizados no lado norte do rio Liffey, enquanto os números pares estão localizados no lado sul. Limerick é a terceira maior cidade da República da Irlanda, localizada no centro-oeste do país, às margens do Rio Shannon. Há uma variedade de bairros em Limerick onde você pode encontrar acomodações, que vão desde áreas estudantis até bairros mais residenciais.",
              },
            ],
          },
          {
            title: "Quanto custa viver na Irlanda?",
            body: [
              {
                type: "p",
                text: "A Irlanda é uma das economias mais importantes da Europa nos dias de hoje. Isso significa que, mesmo que você precise investir um pouco mais de dinheiro para vir estudar aqui, o dinheiro ganho valerá mais do que a sua moeda atual.",
              },
            ],
          },
          {
            title: "Quais documentos eu preciso para trabalhar na Irlanda?",
            body: [
              {
                type: "p",
                text: "Uma vez que você tenha aplicado e recebido seu cartão de residência na Irlanda (IRP), para poder trabalhar, você precisará solicitar seu Número do PPS. Um Número do PPS significa: Número de Serviço Público Pessoal. É um número de referência único que o ajuda a acessar benefícios de bem-estar social, serviços públicos e informações na Irlanda. Para solicitar um Número do PPS, você precisa agendar um horário. Acesse:",
              },
              {
                type: "a",
                link: "http://www.citizensinformation.ie/en/social_welfare/irish_social_welfare_system/personal_public_service_number.html",
                text: "http://www.citizensinformation.ie/en/social_welfare/irish_social_welfare_system/personal_public_service_number.html",
              },
            ],
          },
          {
            title: "Como faço para registrar um emprego com as autoridades?",
            body: [
              {
                type: "p",
                text: "Após conseguir seu primeiro emprego, você precisará gerenciar seus impostos. Isso é muito importante ao morar na Irlanda. Você precisa se cadastrar no site da Receita: ",
              },
              {
                type: "a",
                link: "https://www.revenue.ie/en/Home.aspx",
                text: "https://www.revenue.ie/en/Home.aspx",
              },
            ],
          },
          {
            title:
              "É fácil encontrar um emprego na Irlanda se meu nível de inglês ainda é iniciante?",
            body: [
              {
                type: "p",
                text: "A economia irlandesa tem crescido enormemente nos últimos 10 anos. Isso contribuiu para o aumento da quantidade de empregos disponíveis. Na área de hospitalidade, existem muitos empregos de meio período disponíveis, que muitos estudantes podem assumir. Devido à grande demanda, podemos confirmar que é relativamente fácil encontrar um emprego na Irlanda, mesmo que seu nível de inglês ainda seja iniciante. Além disso, trabalhar é uma ótima maneira de melhorar suas habilidades no idioma. Oferecemos um workshop semanal gratuito de entrevista e preparação de currículo para ajudá-lo a conseguir um emprego o mais rápido possível.",
              },
            ],
          },
          {
            title: "Que tipo de emprego os estudantes costumam conseguir na Irlanda?",
            body: [
              {
                type: "p",
                text: "Como muitos estudantes só podem trabalhar meio período, os tipos de empregos que eles são mais propensos a conseguir estão nos setores de varejo, hospitalidade e cuidados. Isso significa que há muitas opções, como assistente de delicatessen, barista, assistente de vendas, barman, au pair, babá, faxineiro, atendente, garçom/garçonete, auxiliar de cozinha, etc.",
              },
            ],
          },
          {
            title: "Quanto vou receber trabalhando na Irlanda?",
            body: [
              {
                type: "p",
                text: "O salário mínimo na Irlanda é de €11,30 por hora. Isso significa que nenhuma empresa pode pagar menos do que isso. No entanto, dependendo do emprego que você conseguir, o salário por hora pode ser maior, como no setor da saúde. Cuidadores e babás normalmente recebem mais de €12 por hora.",
              },
            ],
          },
        ],
      },
    ],
  },
  privacy_policy: {
    title: "Política de Privacidade",
    breadcr: ["Sobre Nós", ">", "Política de Privacidade"],
    title1: "Pedido de Consentimento",
    text1:
      "O NED College solicita permissão para usar informações pessoais. Você pode solicitar acesso a esses dados a qualquer momento ou nos pedir para removê-los de nossos registros, a menos que os dados sejam mantidos por motivos legais. Pediremos que você aceite esta política de privacidade durante o processo de reserva/matricula. Seu consentimento pode ser retirado a qualquer momento.",
    text2: "Se você tiver alguma dúvida, entre em contato com a escola:",
    text3: "Via correio",
    text4: "Via e-mail",
    text5: "Comissão de Proteção de Dados",
    items: [
      {
        title: "Quem somos?",
        body: [
          {
            type: "p",
            text: "NED College é um Centro de Educação em Línguas (LEC) e somos responsáveis pelo processamento de qualquer informação pessoal que você forneça à escola por meio de nosso site www.ned.ie. Respeitamos seus direitos à privacidade e à proteção de suas informações pessoais. O objetivo deste aviso de privacidade é explicar como coletamos e usamos informações pessoais para fornecer nossos serviços e a gestão diária da escola, bem como delinear seu acesso e controle sobre suas informações pessoais.",
          },
        ],
      },
      {
        title: "O que são informações pessoais?",
        body: [
          {
            type: "p",
            text: "Informações que podem ser usadas para identificá-lo são conhecidas como informações pessoais.",
          },
          {
            type: "p",
            text: "Quando você fornece informações pessoais ao NED College, a escola, como controladora de dados dessas informações, é responsável por como e por que as informações são mantidas.",
          },
        ],
      },
      {
        title: "Tipos de informações que podemos processar",
        body: [
          {
            type: "p",
            text: "Coletamos e processamos várias categorias de informações pessoais, incluindo informações básicas, como nome, data de nascimento e detalhes de contato. Se necessário, podemos coletar detalhes de passaporte e visto, bem como dados relacionados a condições médicas, necessidades especiais e requisitos específicos. Também podemos ocasionalmente coletar informações em forma fotográfica ou de vídeo (mediante consentimento prévio).",
          },
        ],
      },
      {
        title: "Como processamos suas informações pessoais?",
        body: [
          {
            type: "p",
            text: "O processamento de informações pessoais é controlado e regulado pelo Regulamento Geral de Proteção de Dados (GDPR).",
          },
          {
            type: "p",
            text: "Para cumprir o GDPR, o NED College é obrigado a garantir que todos os dados pessoais sejam mantidos atualizados, armazenados com segurança e destruídos de maneira segura, usados apenas para o propósito pelo qual são coletados, protegidos contra perda, acesso e divulgação não autorizados.",
          },
        ],
      },
      {
        title: "Para o que usamos suas informações pessoais?",
        body: [
          {
            type: "p",
            text: "Utilizamos suas informações pessoais apenas para fins específicos relacionados à administração, gerenciamento acadêmico e de negócios da escola, incluindo:",
          },
          {
            type: "ul",
            list: [
              "Matrícula escolar",
              "Processar transações financeiras",
              "Auxiliar em solicitações de visto",
              "Solicitar seguro médico ou de proteção ao estudante",
              "Fins de imigração",
              "Reservar acomodação",
              "Promoção da escola",
            ],
          },
          {
            type: "p",
            text: "Se quisermos usar suas informações pessoais para algum novo propósito, devemos informá-lo antecipadamente e obter seu consentimento prévio para qualquer novo processo.",
          },
        ],
      },
      {
        title: "Segurança",
        body: [
          {
            type: "p",
            text: "Comprometemo-nos a garantir que suas informações pessoais estejam seguras conosco. Todas as informações enviadas diretamente ou por meio do site são totalmente protegidas on-line e off-line. Somente os membros da equipe que precisam das informações para realizar um trabalho específico terão acesso às suas informações pessoais. Todos os computadores e sistemas de arquivamento manual nos quais o NED College armazena informações são mantidos em um ambiente seguro.",
          },
        ],
      },
      {
        title: "Compartilhamento com terceiros",
        body: [
          {
            type: "p",
            text: "Não compartilharemos suas informações pessoais com ninguém fora da escola, a menos que tenhamos sua permissão expressa.",
          },
          {
            type: "p",
            text: "Em nenhuma circunstância venderemos, alugaremos ou compartilharemos suas informações pessoais com terceiros.",
          },
        ],
      },
      {
        title: "Transferência de informações para o exterior",
        body: [
          {
            type: "p",
            text: "Suas informações pessoais só podem ser transferidas para fora da União Europeia se você nos permitir fazê-lo.",
          },
        ],
      },
      {
        title: "Por quanto tempo mantemos suas informações",
        body: [
          {
            type: "p",
            text: "Devido a obrigações/regulamentos legais e operacionais, podemos manter suas informações pessoais por tempo indeterminado, a menos que você solicite que sejam removidas de nosso sistema.",
          },
        ],
      },
      {
        title: "Seus direitos legais",
        body: [
          {
            type: "p",
            class: "fw-bold",
            text: "De acordo com o GDPR, você tem certos direitos legais para controlar suas informações pessoais e a maneira como as processamos. Isso inclui:",
          },
          {
            type: "ul",
            list: [
              "Direito de acesso",
              "Direito de corrigir informações incorretas ou atualizar informações incompletas",
              "Direito de restringir o processamento",
              "Direito de receber informações em formato portátil",
              "Direito de se opor ao processamento de dados para um propósito para o qual não foi fornecido",
              "Direito de retirar seu consentimento a qualquer momento",
              "Direito de apresentar uma reclamação à Comissão de Proteção de Dados",
            ],
          },
        ],
      },
    ],
  },
  services: {
    title: "Mais do que <br> Cursos de Inglês",
    breadcr: ["Vida de estudante", ">", "Serviços"],
    title2:
      "A nossa escola oferece muito mais do que cursos de Inglês, oferecemos a experiência completa!",
    items: [
      {
        image: "services_1",
        title: "Atividades Extras",
        body: [
          {
            type: "p",
            class: "",
            text: "A NED College acredita que o tempo fora da sala de aula é muito importante para ajudá-lo a melhorar o seu idioma e fazer novos amigos. Por isso, oferecemos atividades relacionadas ao processo de aprendizado em si, como aulas extras gratuitas de conversação, pronúncia, gramática e como criar o seu currículo, além de atividades ao ar livre, excursões e viagens, como a nossa viagem para o Marrocos. Todos os meses, você pode conferir a programação completa nos murais da escola, em nossas redes sociais e em nosso aplicativo.",
          },
        ],
      },
      {
        image: "services_2",
        title: "Aplicativo NED College",
        body: [
          {
            type: "p",
            class: "",
            text: "Outra grande vantagem a ser considerada é que a NED College oferece um incrível aplicativo para facilitar a vida dos alunos. O Aplicativo NED College é a melhor ferramenta para acompanhar a sua vida acadêmica, verificar a sua presença, solicitar férias, descobrir as novidades do nosso calendário escolar, participar de atividades e muito mais.",
          },
          {
            type: "p",
            class: "fw-bold",
            text: "Baixe gratuitamente na Google Store ou na Apple Store e faça o seu cadastro utilizando o seu ID de estudante.",
          },
        ],
      },
      {
        image: "services_3",
        title: "Apoio ao aluno",
        body: [
          {
            type: "p",
            class: "",
            text: "Na NED College, os estudantes podem contar com suporte profissional em seu próprio idioma. Todos os membros da nossa equipe estudaram no exterior e viveram a mesma experiência que os nossos alunos. Portanto, eles irão ajudá-lo antes da sua chegada à Irlanda e durante o período de estudos aqui. Nossos consultores de estudantes compreendem completamente o que significa viver no exterior. Eles vão te orientar, do começo ao fim, sobre o curso de Inglês, visto, acomodação, transporte público, permissão de trabalho e como aproveitar ao máximo a sua experiência em Dublin ou Limerick.",
          },
        ],
      },
      {
        image: "services_4",
        title: "Acomodação temporária na Irlanda",
        body: [
          {
            type: "p",
            class: "",
            text: "O nosso objetivo é fazer com que você se sinta em casa na Irlanda. A sua acomodação é uma parte extremamente importante de toda a sua experiência. As diferentes localizações onde acomodamos os estudantes estão todas próximas a transportes públicos, centros comerciais, supermercados e bancos. Com a NED College, você pode ter a certeza de que iremos fornecer uma acomodação de qualidade que melhor atenda às suas necessidades. Trabalhamos com Famílias Anfitriãs, Albergues e Acomodações Estudantis. Fale com a nossa equipe para ver qual é a melhor opção para você, levando em consideração as suas necessidades e o seu orçamento.",
          },
        ],
      },
      {
        image: "services_5",
        title: "Traslado do aeroporto",
        body: [
          {
            type: "p",
            class: "",
            text: "Quando você chegar em Dublin ou Limerick para fazer os nossos cursos de Inglês, poderemos providenciar um serviço de traslado do aeroporto. Esse serviço garante uma chegada conveniente e segura até a sua residência, hotel ou albergue.",
          },
        ],
      },
      {
        image: "services_6",
        title: "Cartão de estudante da NED College",
        body: [
          {
            type: "p",
            class: "",
            text: "A NED College possui o seu próprio cartão de estudante, que oferece descontos para os nossos alunos em diversas lojas, restaurantes, cinemas e muito mais. Todos os estudantes podem adquirir esse cartão gratuitamente e ele será válido durante o período da estadia na Irlanda. Com ele, você terá descontos e ofertas especiais!",
          },
        ],
      },
      {
        image: "services_7",
        title: "Proteção para estudantes matriculados",
        body: [
          {
            type: "p",
            class: "",
            text: "De acordo com as regulamentações nacionais vigentes, todos os estudantes matriculados em cursos com duração de 3 meses ou mais são obrigados a adquirir a Proteção para Estudantes como parte das taxas do curso. Esse seguro protege as taxas do estudante no caso improvável de algo acontecer com a escola.",
          },
        ],
      },
      {
        image: "services_8",
        title: "Seguro de saúde",
        body: [
          {
            type: "p",
            class: "",
            text: "Nós iremos lhe proporcionar suporte para solicitar o seu Seguro de Saúde após a sua chegada na Irlanda e antes de ir ao Escritório de Imigração. Lembre-se de que o seguro médico é obrigatório para estudantes que necessitam de visto.",
          },
        ],
      },
      {
        image: "services_9",
        title: "Dia de recepção",
        body: [
          {
            type: "p",
            class: "",
            text: "Assim que o estudante chegar e antes de iniciar o curso, a nossa equipe realizará um dia de recepção. Essa reunião é de extrema importância para nós! Ela é feita para informar aos estudantes tudo sobre a NED College e a experiência que eles estão prestes a começar. Todos os detalhes serão explicados em seus próprios idiomas, para que sejam plenamente compreendidos!",
          },
        ],
      },
      {
        image: "services_10",
        title: "Exames e Certificação de Inglês",
        body: [
          {
            type: "p",
            class: "",
            text: "Acreditamos que estabelecer uma meta é a melhor maneira de se motivar e ajudar a si mesmo a alcançar seus objetivos. Exames de língua inglesa, como os exames da Cambridge e o TIE, são ótimos motivadores para você estudar e se esforçar durante o seu tempo na Irlanda. Aqui na NED College, oferecemos preparação para exames para ajudá-lo a alcançar esses objetivos importantes. Lembre-se de que, para os estudantes da NED College matriculados em um curso de 25 semanas, é obrigatório realizar um exame no final do programa.",
          },
        ],
      },
      {
        image: "services_11",
        title: "Estudante do mês",
        body: [
          {
            type: "p",
            class: "",
            text: "Todos os meses, os nossos professores indicam um estudante para ser o 'Estudante do Mês'. Isso pode ser concedido devido ao seu progresso, participação em sala de aula ou talvez você tenha aquela qualidade especial que o torna um ótimo estudante.",
          },
        ],
      },
    ],
    button: "Quero mais informações",
  },
  student_visa: {
    title: "Estudar e trabalhar na Irlanda",
    section1: {
      title: "Visto de estudante e regras de imigração",
      subtitle:
        "Para obter um visto de estudante e residir legalmente na Irlanda por um período superior a 90 dias, é necessário solicitar uma Permissão de Residência Irlandesa (IRP)",
      text1:
        "Por favor, note que certas nacionalidades precisam solicitar um visto antes de viajar para a Irlanda. Uma lista dessas nacionalidades pode ser encontrada no site do escritório de imigração irlandês",
      text2: "ou entrando em contato com a embaixada relevante.",
    },
    section2: {
      title:
        "Ao imigrar para a Irlanda de um país não europeu para estudar inglês, é essencial ter a documentação apropriada para garantir um processo de solicitação de visto tranquilo e bem-sucedido.",
      subtitle:
        "Os seguintes documentos são necessários para cursos de inglês de curta e longa duração:",
      subtitle_left: "Curso de inglês de curta duração",
      list1_left: "Passaporte original, válido durante todo o período de estadia no país",
      list2_left: "Passagens de volta para o país de origem",
      list3_left:
        "Carta de inscrição da NED College, incluindo informações sobre o curso e confirmação de pagamento de todas as taxas",
      list4_left:
        "Carta de confirmação da residência, casa, hotel ou hostel onde o estudante ficará hospedado",
      list5_left: "Comprovante financeiro, variando de €500 a €700 por mês",
      list6_left: "Seguro de saúde privado",
      text1: "Algumas nacionalidades devem solicitar o visto antes de viajar para a Irlanda:",
      subtitle_right: "Curso de inglês de longa duração",
      list1_right: "Passaporte original, válido durante todo o período de estadia no país",
      list2_right:
        "Carta de inscrição da NED College, incluindo informações sobre o curso e confirmação de pagamento de todas as taxas",
      list3_right:
        "Carta de confirmação da residência, casa, hotel ou hostel onde o estudante ficará hospedado",
      list4_right: "Seguro governamental (obrigatório) e seguro de saúde privado (opcional)",
      list5_right:
        "Comprovante financeiro de €3.000 (A partir de 01 de julho de 2023, será necessário comprovar acesso a pelo menos €10.000 por ano de estudos. Se a duração do curso for inferior a 6 meses, será necessário comprovar acesso a €4.200).",
      list6_right: "€300 para o visto e registro IRP",
      text2: "Algumas nacionalidades devem solicitar o visto antes de viajar para a Irlanda",
      button: "Verificar lista de Nacionalidades",
    },
    section3: {
      title1: "Embora a pessoa solicitante seja responsável por obter o visto,",
      title2: "nossos consultores estudantis irão ajudá-lo durante todo o processo de solicitação.",
      button: "Quero falar com um agente",
    },
    section4: {
      title: "Análise do pedido",
      text1: "Após enviar os documentos necessários e pagar a taxa,",
      text2:
        "o escritório de imigração irá analisar os documentos e conceder a permissão de residência,",
      text3:
        "que incluirá o registro dos dados pessoais do solicitante (impressões digitais e foto).",
      text4:
        "Todo o processo geralmente leva cerca de uma hora, embora às vezes possa estar mais movimentado. Ao concluí-lo, o escritório colocará um carimbo no passaporte indicando a",
      text5: "permissão de residência e o horário permitido para trabalhar (Carimbo 2).",
      card_icon: "exclamation",
      card_title:
        "É importante destacar que os estudantes devem sempre portar seu IRP ao viajar para fora da Irlanda e ao retornar ao país.",
      card_body:
        "Além disso, não é permitido sair do país e entrar novamente como turista após a expiração do visto. Nossos consultores estudantis estão disponíveis para ajudar durante todo o processo de solicitação. Para obter mais informações, consulte o site do Escritório de Imigração Irlandês e entre em contato com sua embaixada para obter detalhes adicionais.",
    },
  },
  terms_and_conditions: {
    title: "Termos e <br> Condições",
    breadcr: ["Sobre Nós", ">", "Termos e condições"],
    section: {
      title: "Termos e Condições do NED College",
      subtitle: "Geral",
      list1:
        "É dever do estudante garantir que ele/ela leia e entenda os Termos e Condições aqui contidos. Ao assinar os termos e condições, o estudante concorda com as informações indicadas no e-mail de oferta (itens do pacote, taxas, data de início do curso) feito pelo NED College e entra em um contrato com o NED College pelo período indicado no 'E-mail de Cotação', do 'Curso Data de Início' ao 'Data de Conclusão do Curso', sujeito às cláusulas descritas aqui.",
      list2:
        "Os cursos serão reservados após a assinatura dos termos e condições e após o pagamento integral das taxas do curso. A taxa do curso deve ser totalmente paga pelo menos 3 meses antes da data de início do curso. <br /> <b>ATENÇÃO:</b> Um passaporte válido deve ser enviado juntamente com as passagens aéreas.",
      list3:
        "Devido à possibilidade de circunstâncias imprevistas durante o ano letivo, os horários dos estudantes podem mudar durante o ano. Todo esforço é feito para evitar tais ocorrências. No entanto, caso seja necessário, o Departamento Acadêmico do NED College não se responsabiliza em nenhuma circunstância, e portanto nenhuma compensação ou reembolso será fornecido caso alguma ação desse tipo seja necessária.",
      list4:
        "Todos os novos estudantes do NED College devem realizar o teste de colocação de turma e o teste oral. Caso isso não seja concluído antes da data de início planejada, o aluno não será autorizado a começar na data de início originalmente planejada.",
      list5:
        "O aluno será colocado de acordo com a habilidade e a disponibilidade de cada nível. O aluno pode solicitar a mudança de nível, mas isso só será aprovado quando o aluno atingir o padrão necessário e se houver espaço disponível. Se o aluno atingir o nível necessário, mas não houver espaço disponível, ele/ela deve continuar frequentando as aulas até receber um e-mail o colocando na nova turma. A escola se esforçará para garantir que essa possível espera seja minimizada. Caso o aluno queira mudar de turma da tarde para a turma da manhã, uma taxa administrativa será cobrada. Caso o aluno queira mudar da turma da manhã para a turma da tarde, nenhuma taxa administrativa será aplicada. Em ambos os casos, pode ser necessário aguardar um período de tempo. <br /> <b>ATENÇÃO:</b> Em nenhuma circunstância as taxas da manhã são reembolsáveis.",
      list6:
        "O NED College se reserva o direito de suspender ou expulsar qualquer estudante que não cumpra os requisitos necessários dos estudantes. O mesmo se aplica a perturbações comportamentais à conduta geral do NED College. Em ambos os casos, não será aplicável ou fornecido reembolso das taxas.",
      list7:
        "É proibido que os estudantes filmem ou tirem fotos durante as aulas, sem a permissão expressa do professor.",
      list8:
        "O aluno aceita a condição de que o livro didático é obrigatório e deve estar presente para ter acesso à aula. O livro didático é obrigatório em todos os níveis e o aluno aceita que deve tê-lo em mãos para frequentar as aulas. Os estudantes podem precisar comprar mais de um livro durante a duração do curso. Qualquer estudante que não tenha o livro incluído no registro deve adquiri-lo durante a primeira semana do curso. Se algum nível ou curso específico exigir dois livros diferentes, o NED College não se responsabilizará por fornecer mais livros do que o aluno tenha comprado ou estejam incluídos no registro. O NED College não oferece a troca de livros novos ou usados em nenhuma circunstância.",
      list9:
        "Uma vez que o curso esteja totalmente pago, espera-se que os estudantes cheguem na Irlanda dentro de um ano. Haverá uma taxa adicional se os estudantes decidirem estender a data de chegada.",
      list10:
        "Para melhorar a qualidade dos cursos e serviços, o NED College reserva-se o direito de modificar os Termos e Condições e qualquer aspecto dos cursos sem aviso prévio. No entanto, se tais ações forem tomadas, os estudantes serão notificados para se adequarem às novas cláusulas.",
      list11:
        "O NED College não será responsável por pagamentos feitos em contas diferentes dos meios de pagamento oficiais do NED College, que incluem a plataforma de pagamento online Flywire, a conta do Escritório Internacional do NED College (Chile, Uruguai e Malásia) e transferências diretas para a conta bancária do NED College (nome da conta registrado como National Employee Development Training Center). O NED College também tem um parceiro no Brasil chamado LF TURISMO. <br /> <b>ATENÇÃO:</b> Qualquer solicitação de pagamento para outra conta bancária deve ser comunicada imediatamente diretamente à equipe administrativa do NED College (info@ned.ie). O NED College não se responsabilizará por quantias pagas para destinos diferentes dos mencionados acima.",
      list12:
        "Todas as disponibilidades em relação às datas de início do curso, acomodação e traslados para o aeroporto precisam ser verificadas e reservadas antecipadamente. O NED College não se responsabilizará por reservar qualquer serviço se a disponibilidade não tiver sido confirmada antecipadamente. Para garantir o espaço de matrícula, acomodação e traslado para o aeroporto (se incluído no pacote), a confirmação da passagem aérea precisa ser enviada pelo menos 3 meses antes da data planejada de início do curso/ chegada. Se o estudante enviar as passagens aéreas sem confirmação prévia do NED College, não seremos responsáveis pela reserva de nenhum serviço e nenhuma restituição será aplicada. <br /> <b>ATENÇÃO:</b> Os estudantes devem receber a confirmação do NED College em relação à disponibilidade antes de reservar as passagens aéreas.",
      list13:
        "Itens promocionais do pacote não são reembolsáveis e não podem ser transferidos para o próximo curso. Isso é válido mesmo que tenham sido utilizados ou não.",
      list14:
        "O NED College não oferece estacionamento privado em nenhuma de suas instalações. <br /> <b>ATENÇÃO:</b> O NED College não oferece estacionamento para carros, scooters, bicicletas, etc. O NED College não se responsabiliza por perda, danos ou roubo de pertences pessoais.",
      list15:
        "Estudantes participantes de cursos de curta duração e estudantes que não necessitam de visto de estudante também devem cumprir as políticas do NED College descritas neste documento.",
      list16:
        "O uso das instalações do NED College para fins comerciais é estritamente proibido. <br /> <b>ATENÇÃO:</b> Em nenhuma circunstância os estudantes podem vender alimentos ou outros itens dentro ou nas proximidades de qualquer uma das instalações do NED College.",
      list17:
        "<b>Estudantes inscritos no curso de preparação para o exame IELTS:</b> é responsabilidade do estudante ter o nível mínimo necessário para fazer o curso de preparação para o exame IELTS. No caso em que o nível não atenda ao mínimo exigido, não haverá motivo para compensação ou reembolso.",
    },
    items: [
      {
        title: "Aulas on-line ao vivo em caso de fechamento temporário da escola",
        body: [
          {
            type: "p",
            text: "No caso de fechamento temporário da escola devido a circunstâncias imprevistas ou força maior; nenhum reembolso será aplicado, pois o NED College continuará a apoiar os alunos em todos os aspectos do seu curso. As aulas do NED College serão ministradas por meio de sessões ao vivo no Zoom ou plataformas semelhantes online. As aulas serão divididas em diferentes níveis. Os alunos devem seguir as instruções do professor.",
          },
          {
            type: "p",
            text: "As aulas on-line do NED College permitem que professores e alunos interajam de forma dinâmica, portanto, o professor pode pedir que você ligue seu microfone e/ou câmera para interagir com ele/a e com a turma, responder perguntas exibidas na tela, seguir um quadro digital para fazer exemplos, etc. Compartilhar seus dados pessoais/login com pessoas não matriculadas no NED College é estritamente proibido.",
          },
          {
            type: "b",
            text: "OBSERVE:",
          },
          {
            type: "p",
            text: "O NED College não tem responsabilidade de fornecer aos alunos dispositivos eletrônicos, conectividade com a internet, etc. Isso é responsabilidade do aluno.",
          },
          {
            type: "p",
            text: "Compartilhar seus dados pessoais/login com pessoas não matriculadas no NED College pode resultar em expulsão e não haverá reembolso das taxas aplicável ou concedido.",
          },
        ],
      },
      {
        title: "Coleta de dados biométricos",
        body: [
          {
            type: "p",
            text: "Todos os alunos são solicitados a consentir com a coleta de dados biométricos pelo NED College. Após sua chegada na Irlanda, o aluno deve se apresentar no departamento de apoio para ter seus dados biométricos registrados no sistema do NED College. Caso o aluno não se apresente para o registro, as aulas serão atrasadas, o que pode resultar em perda de presença. Os dados biométricos coletados serão usados exclusivamente para o cálculo e manutenção dos registros de presença, de acordo com os requisitos de presença do ILEP e das autoridades de imigração irlandesas.",
          },
        ],
      },
      {
        title: "Pontualidade, assiduidade, absentismo e expulsão",
        body: [
          {
            type: "p",
            text: "Todos os estudantes devem comparecer às aulas e manter uma taxa mínima de assiduidade de 85%. Cada sala de aula contém um leitor biométrico, no qual os estudantes devem se apresentar no início da aula (ou na chegada) para registrar sua presença no dia. No final da aula (ou ao sair), os estudantes devem novamente se apresentar ao leitor para completar o registro de presença do dia. Esses dados biométricos são coletados e armazenados exclusivamente pelo NED College para o cálculo e manutenção dos registros de assiduidade.<br>\nOs estudantes devem se registrar o tempo todo, independentemente de estarem atrasados ou não. Atrasos não são tolerados e qualquer estudante que chegar após o início da aula perderá a presença na primeira metade da aula. Da mesma forma, se um estudante sair da aula mais cedo, perderá a presença na segunda metade da aula. Se os estudantes esquecerem de se apresentar ao leitor, perderão a presença.<br>\nCaso o estudante não consiga completar seu curso com uma assiduidade mínima de 85%, o NED College não se responsabiliza por qualquer problema que isso possa causar durante a renovação potencial do visto do estudante. A assiduidade é uma condição do visto do estudante e a falta de assiduidade resultará em expulsão. Por lei, o NED College deve notificar as autoridades de imigração irlandesas de todas as expulsões. A expulsão pode afetar a permissão do estudante para estudar/trabalhar na Irlanda.<br>\nA ausência do estudante será registrada como não comparecimento, a menos que seja apresentado um atestado médico verificado. Estudantes que comparecerem às suas provas finais do curso ou a compromissos nos escritórios de imigração não serão considerados ausentes da escola, no entanto, comprovantes devem ser apresentados ao Departamento Acadêmico do NED College (Dublin: support.dublin@ned.ie Limerick: support.limerick@ned.ie).<br>\nEm caso de doença: espera-se que os estudantes apresentem um atestado médico para cobrir a(s) ausência(s). Essa documentação deve ser apresentada ao Departamento Acadêmico do NED College o mais cedo possível. Essas informações e documentos serão analisados e verificados, e uma decisão será tomada em relação à assiduidade.<br>\n",
          },
          {
            type: "b",
            text: "POR FAVOR, OBSERVE:",
          },
          {
            type: "p",
            text: "Apenas atestados médicos emitidos na Irlanda serão aceitos.",
          },
          {
            type: "p",
            text: "Toda a documentação relacionada à ausência de assiduidade é verificada pelo Departamento Acadêmico. Estudantes que apresentarem documentação falsa receberão advertências e, dependendo da gravidade da situação, as autoridades de imigração poderão ser informadas.",
          },
        ],
      },
      {
        title: "Política de Frequência",
        body: [
          {
            type: "p",
            text: "Em conformidade com os requisitos da ILEP e das autoridades de imigração irlandesas, espera-se que os estudantes do NED College mantenham uma taxa de frequência de pelo menos 85% durante todo o curso. Se a escola perceber que a frequência de um aluno está abaixo do necessário, há uma série de medidas que a escola é obrigada a tomar:",
          },
          {
            type: "ul",
            list: [
              {
                title: "Primeiro Aviso de Frequência:",
                text: "Os primeiros avisos de frequência são emitidos aos alunos nos casos em que é observado que a frequência caiu pela primeira vez durante o curso do aluno.",
              },
              {
                title: "Segundo Aviso de Frequência:",
                text: "Os alunos que receberam um primeiro aviso de frequência, mas não tomaram medidas para melhorar sua frequência, receberão um segundo aviso de frequência.",
              },
              {
                title: "Terceiro Aviso de Frequência:",
                text: "No caso de um aluno já ter recebido dois avisos, mas não ter feito nenhum esforço para melhorar a frequência, ele/ela receberá um terceiro aviso. Os alunos que receberem um terceiro aviso de frequência devem comunicar à nossa equipe administrativa por e-mail para explicar a sua situação.",
              },
              {
                title: "Quarto Aviso de Frequência:",
                text: "Esta é a etapa final antes da expulsão. Um aluno que receber um quarto aviso de frequência tem um histórico de baixa frequência e foi devidamente informado das consequências de não atender aos requisitos de frequência. O NED College reserva-se o direito de não emitir o quarto aviso de frequência nos casos em que os alunos não fizeram nenhum esforço para se envolver com a escola ou melhorar a frequência.",
              },
            ],
          },
          {
            type: "p",
            text: "Em qualquer momento durante o processo descrito acima, os alunos são bem-vindos e incentivados a discutir qualquer problema(s) que possa estar contribuindo para eles não conseguirem atender aos requisitos de frequência. A escola possui uma política de portas abertas, com vários funcionários disponíveis, bem como várias opções de comunicação abertas aos alunos.",
          },
          {
            type: "p",
            text: "Se durante o processo descrito acima, um aluno;",
          },
          {
            type: "p",
            text: "(A) Não responder/interagir/engajar-se com a escola;",
          },
          {
            type: "p",
            text: "(B) Continuar a faltar às aulas;",
          },
          {
            type: "p",
            text: "(C) Se um aluno não conseguir atingir uma frequência de 85% até o final de seu curso, o NED College reserva-se o direito de expulsá-lo sem emitir todos os avisos.",
          },
        ],
      },
      {
        title: "Férias e pausas",
        body: [
          {
            type: "p",
            text: "Todos os estudantes do Colégio NED recebem 2 semanas de férias no período de Natal e 1 semana na Páscoa, pois a escola está fechada durante esses períodos. Todos os outros períodos de férias para os estudantes devem ser solicitados pelos alunos através do aplicativo do Colégio NED. A concessão de férias está sujeita a condições e à discricionariedade da escola.",
          },
          {
            type: "p",
            text: "Para serem aprovadas as férias: os estudantes devem completar um mínimo de 8 semanas de curso, manter 85% de frequência e ter mais de 4 semanas antes do término do curso. O período de férias solicitado deve iniciar na segunda-feira e terminar na sexta-feira. Os alunos podem solicitar um máximo de 7 semanas de férias durante um curso.",
          },
        ],
      },
      {
        title: "Fim de exames de programa",
        body: [
          {
            type: "p",
            text: "Os exames de fim de programa são obrigatórios para todos os estudantes do NED College. Esse fato é claramente comunicado aos alunos no momento da compra do curso e está de acordo com as regulamentações das Autoridades de Imigração Irlandesas. O aluno concorda em entender que o exame do fim do programa é obrigatório e concorda em fazer o exame com uma possível taxa adicional. Não fazer este exame obrigatório pode resultar na expulsão do aluno e/ou na notificação das autoridades de imigração. Também pode afetar o direito do aluno de permanecer na Irlanda de acordo com as regulamentações das autoridades imigratórias irlandesas.",
          },
          {
            type: "b",
            text: "POR FAVOR, ATENÇÃO:",
          },
          {
            type: "p",
            text: "Cada curso exige a compra do exame. A inscrição no exame não pode ser transferida de um curso para outro.",
          },
        ],
      },
      {
        title: "Proteção dos aprendizes matriculados",
        body: [
          {
            type: "p",
            text: "De acordo com as regulamentações nacionais, todos os estudantes matriculados em cursos com duração de 3 meses ou mais são obrigados a adquirir Proteção do Aprendiz como parte das taxas do curso. Esta é um seguro que protege as taxas do estudante no caso improvável de algo acontecer com a escola.",
          },
          {
            type: "b",
            text: "ATENÇÃO:",
          },
          {
            type: "p",
            text: "A apólice de seguro oferecida pela NED College combina o Seguro de Proteção do Aprendiz e o Seguro Médico.",
          },
        ],
      },
      {
        title: "Materiais de Fotografia e Filmagem",
        body: [
          {
            type: "p",
            text: "Ao aceitar estes termos e condições, os estudantes aceitam que fotos ou vídeos de eventos ou aulas possam ser gravados e utilizados para fins promocionais.",
          },
        ],
      },
      {
        title: "Responsabilidade",
        body: [
          {
            type: "p",
            text: "A NED College não se responsabiliza no caso de qualquer serviço contratado (pelo estudante) e que tenha se tornar impossível de ser fornecido por motivos de disputa industrial ou qualquer outra causa fora do controle da NED College (força maior).",
          },
          {
            type: "p",
            text: "A NED College não será responsável por perda, dano ou lesão a pessoas ou propriedades, salvo nos casos em que a responsabilidade seja expressamente imposta além da exclusão por lei. Todos os cancelamentos de acomodação e traslado do aeroporto que ocorrerem 30 dias ou menos antes da data de chegada não são reembolsáveis (isso inclui cancelamentos pelas companhias aéreas). O mesmo se aplica se o(s) estudante(s) tiver(em) que encurtar sua estadia - o pagamento não é reembolsável. ",
          },
          {
            type: "b",
            text: "ATENÇÃO:",
          },
          {
            type: "p",
            text: "A acomodação, o traslado do aeroporto ou quaisquer serviços adicionais não são transferíveis se cancelados ou adiados.",
          },
        ],
      },
      {
        title: "Política de cancelamento e reembolso",
        body: [
          {
            type: "p",
            text: "Reembolsos, reembolsos parciais de taxas ou créditos só são considerados nas seguintes circunstâncias:",
          },
          {
            type: "p",
            text: "(A) Recusa de visto (visto de entrada irlandês ou extensão de visto de estudante irlandês (Carimbo 2)) em apelação, quando o estudante não possui condenações prévias ou histórico de imigração. A carta de rejeição emitida pela imigração será avaliada pela NED College a fim de verificar os motivos para qualquer reembolso",
          },
          {
            type: "p",
            text: "(B) Doença ou incapacidade sofrida após a confirmação da inscrição do aluno. Em qualquer uma dessas situações, será exigido um atestado médico",
          },
          {
            type: "p",
            text: "(C) Caso um aluno seja impedido de entrar na Irlanda por qualquer motivo, a carta de rejeição emitida pela GNIB será avaliada pela NED College para verificar os motivos para qualquer reembolso",
          },
          {
            type: "p",
            text: "(D) Cancelamento do curso e ausência de um curso alternativo disponível na NED College",
          },
          {
            type: "p",
            text: "(E) Luto familiar",
          },
          {
            type: "p",
            text: "(F) Quando um aluno decide cancelar seu curso antes de concluir o pagamento integral do programa",
          },
          {
            type: "b",
            text: "POR FAVOR, OBSERVE:",
          },
          {
            type: "p",
            text: "O pagamento integral das taxas do curso é necessário antes que a matrícula possa ser realizada.",
          },
          {
            type: "ol",
            list: [
              "O reembolso só será concedido em relação às taxas pagas dentro de 1 ano em que ocorra (A) a (F). Não há direito automático a reembolso de taxas se, a qualquer momento, o aluno mudar de ideia sobre estudar na NED College.",
              "Será deduzida uma Taxa Administrativa de 25% do valor total de todos os reembolsos concedidos.",
              "Os reembolsos não podem ser feitos após o envio da carta de matrícula, após a chegada à Irlanda e/ou após a concessão do visto. O mesmo se aplica a quaisquer serviços adicionais emitidos, como seguro médico, proteção ao aluno, acomodação e prova de fim de programa.",
              "Todas as solicitações de cancelamento de curso que envolvam solicitações de reembolso devem ser direcionadas ao seu consultor de vendas ou usando o 'Formulário de Solicitação de Reembolso' da NED College com 2 meses de antecedência em relação à data de início do curso.",
              "Alunos que fornecerem informações falsas ou incorretas, resultando na recusa de visto, não terão direito a qualquer forma de reembolso.",
              "Embora as datas de início e término do curso não sejam esperadas para mudar, a NED College reserva-se o direito de alterar quaisquer datas anteriormente detalhadas para facilitar ou melhorar a oferta de qualquer curso e qualquer exame associado. Essas alterações não afetarão de forma alguma os outros termos e condições do contrato do aluno com a NED College. Caso seja necessária uma alteração, a NED College não será responsável por fornecer qualquer forma de compensação ou reembolso.",
              "O valor reembolsável será calculado com base no valor recebido pela NED College. Se um aluno pagou por meio de qualquer banco internacional ou plataforma de pagamento, como Stripe, TransferMate, PayPal, Flywire, Western Union, Global 66, poderá haver uma taxa de até 6% que foi aplicada ao pagamento e que será deduzida do valor reembolsável, além da taxa administrativa de 25%.",
              "Todas as solicitações de reembolso de alunos são revisadas semanalmente pela equipe administrativa e, se aprovadas, o pagamento será feito ao aluno dentro de 2 meses em que ocorra (A) a (F), exceto no caso de recusa de visto de entrada irlandesa.",
              "Após a concessão de um visto de entrada irlandês ou visto de estudante irlandês (Carimbo 2), não são aplicáveis ou disponíveis reembolsos.",
              "Para cumprir a legislação contra lavagem de dinheiro, reembolsos/transfers só podem ser feitos para a pessoa que reservou/pagou pelo curso. Os reembolsos serão enviados ao aluno em euros ou na mesma moeda que o aluno tenha pago, e é responsabilidade do aluno fornecer as informações bancárias apropriadas para receber fundos da Irlanda, como o IBAN e outras informações necessárias. Se a NED College informou os dados bancários incorretos e os fundos retornaram, a taxa de transação bancária será deduzida da próxima tentativa de transferência bancária.",
              "NOTA DE CRÉDITONo lugar de um reembolso, os alunos podem solicitar uma nota de crédito em caso de ocorrência de (A) a (F). As notas de crédito podem ser solicitadas por meio do 'Formulário de Solicitação de Reembolso' da NED College, e a equipe administrativa da NED College avaliará e emitirá uma nota de crédito do valor recebido pela NED College.",
            ],
          },
          {
            type: "p",
            text: "Os alunos podem não ser capazes de trocar a nota de crédito por dinheiro ou transferência bancária;",
          },
          {
            type: "p",
            text: "Os alunos podem usar o crédito no futuro ou transferi-lo para outra pessoa. O valor da nota de crédito será mostrado apenas para o valor recebido pela NED College, portanto, não garante o mesmo preço e detalhes do pacote promocional que o aluno tinha originalmente adquirido. As notas de crédito são válidas por 1 ano a partir da data de emissão. Se esse período expirar, a nota de crédito não será mais válida. As notas de crédito não são reembolsáveis em nenhum momento e podem ser emitidas e resgatadas apenas uma vez por pagamento. Se uma pessoa que resgatou uma nota de crédito quiser cancelar ou solicitar a nota de crédito novamente, isso será negado.",
          },
          {
            type: "p",
            text: "Para receber uma nota de crédito, os alunos devem notificar a NED College no mínimo 2 meses antes da data de início do curso e/ou dentro de 1 ano do primeiro pagamento realizado. Quando aprovado, o programa do aluno será cancelado imediatamente, e o contrato com a NED College não será mais válido.",
          },
          {
            type: "p",
            text: "Para resgatar uma nota de crédito, os alunos devem notificar a NED College com no mínimo 3 meses de antecedência à data de início do curso desejado. A pessoa que vai resgatar a nota de crédito deve seguir a lista de preços atual e o preço promocional.",
          },
          {
            type: "p",
            text: "Se houver algum saldo excedente, este será emitido como uma nota de crédito.",
          },
          {
            type: "p",
            text: "Para transferir uma nota de crédito, os alunos devem assinar um acordo de transferência de nota de crédito (este documento pode ser fornecido pelo consultor de vendas). Este acordo de transferência de nota de crédito assinado deve ser fornecido à NED College juntamente com a nota original.",
          },
          {
            type: "b",
            text: "Após receber um visto de entrada irlandês ou visto de estudante irlandês (Carimbo 2), os alunos não podem solicitar uma nota de crédito. A NED College tem o direito de recusar a emissão de uma nota de crédito, solicitando aos alunos que forneçam evidências adequadas, como carta de rejeição de visto de entrada irlandesa, atestado médico e cartão de embarque do voo. Qualquer taxa de serviço utilizada, como seguro e proteção ao estudante, prova de fim de programa, livro didático, será deduzida do valor do crédito.",
          },
        ],
      },
    ],
  },
  careers: {
    title: "Carreiras",
    breadcr: ["Sobre nós", ">", "Carreiras"],
    section1: {
      title: "Bem-vindo(a) às Carreiras do NED College!",
      text: "Descubra um mundo de oportunidades no NED College, onde a diversidade prospera e a aprendizagem não tem limites. Junte-se à nossa equipe multicultural e dê início à sua carreira internacional. Com a gente, você não apenas se destacará profissionalmente, mas também mergulhará em uma comunidade vibrante, desenvolverá suas habilidades e aprimorará sua fluência na língua inglesa. Convidamos você a explorar nossas vagas abertas e fazer parte da nossa missão de fornecer educação de primeira linha e suporte aos nossos alunos, ao mesmo tempo em que nutre suas próprias aspirações de carreira.",
    },
  },

  financial_plan: {
    title: `<span class="text-green3">Guia de Planejamento Financeiro para Estudar na Irlanda.</span> Dê seu primeiro passo!`,
    welcome: {
      title: "Bem-vindo ao Guia de Planejamento Financeiro para Estudar na Irlanda!",
      subtitle: "Sonha em fazer intercâmbio na Ilha da Esmeralda? Então, este e-book é para você.",
      text: "Sabemos que a parte financeira é desafiadora e, por isso, criamos um guia completo que permitirá realizar seu sonho sem preocupações.",
    },
    why: {
      title: "Porque você deve baixar esse guia?",

      items: [
        {
          icon: "/landings/financial_plan/icon_1.png",
          text: 'Defina seus <span class="text-green3">objetivos com o intercâmbio</span> e entenda os custos envolvidos.',
        },
        {
          icon: "/landings/financial_plan/icon_2.png",
          text: 'Descubra como criar um <span class="text-green3">orçamento personalizado</span> para a sua realidade.',
        },
        {
          icon: "/landings/financial_plan/icon_3.png",
          text: 'Aprenda como <span class="text-green3">economizar e administrar seu dinheiro</span> antes e durante o intercâmbio.',
        },
        {
          icon: "/landings/financial_plan/icon_4.png",
          text: 'Saiba como <span class="text-green3">arrumar um emprego durante o intercâmbio</span> para te auxiliar a pagar as despesas.',
        },
        {
          icon: "/landings/financial_plan/icon_5.png",
          text: 'Confira dicas para lidar com <span class="text-green3">imprevistos e emergências financeiras</span> que possam ocorrer.',
        },
      ],
    },
    cta: "Faça o download aqui!",
    cta_title:
      'Baixe agora mesmo o <span class="text-blue2">Guia de Planejamento Financeiro para Estudar na Irlanda</span> e comece a transformar seu sonho de intercâmbio em realidade!',
    footer: {
      campus: "Dublin & Limerick",
    },
    form: {
      title: "Preencha o formulário abaixo para receber o e-book diretamente no seu e-mail",
      name: `Seu Nome completo`,
      email: `Seu melhor e-mail`,
      whatsapp: `Phone number/WhatsApp`,
      nationality: `Escolha a sua nacionalidade`,
      campus: `Qual campus você quer estudar?`,
      mkt_source: `Como conheceu nosso eBook?`,
      button: `Baixar meu ebook agora!`,
    },
    ebook_thumb: "/landings/financial_plan/ebook-thumb-pt.png",
  },
  financial_plan_thanks: {
    title: `Obrigado por baixar o Guia de Planejamento Financeiro para Estudar na Irlanda!`,
    first_step: {
      title: "Seu primeiro passo foi dado para realizar o sonho de fazer um intercâmbio!",
      subtitle:
        "Aproveite as nossas dicas e comece a se preparar para viver a melhor experiência da sua vida.",
      bold: "Conte conosco para te ajudar nessa jornada!",
    },
    socials: {
      title: "Acompanhe o dia a dia da nossa escola e veja como é a vida de nossos alunos!",
      subtitle: "Siga-nos nas redes sociais!",
    },
    footer: {
      campus: "Dublin & Limerick",
    },
    ebook_thumb: "/landings/financial_plan/ebook-thumb-pt.png",
  },
  partnership: {
    topbar: "<b>Uma <span class='text-green3'>nova jornada</span> está prestes a começar</b>",
    header: {
      title: "Bem-vindo à nossa <span class='text-green3'>área de parceria</span>",
      subtitle:
        "Aqui você pode encontrar tudo sobre nós, incluindo fotos, vídeos, brochuras e muito mais.",
    },
    about: {
      title: 'Sobre <span class="text-blue2">nossa escola</span>',
      subtitle:
        "Somos uma escola de inglês localizada na Irlanda desde 2011. Com campus em Dublin e Limerick, temos ajudado alunos de todo o mundo a aprimorar suas habilidades em inglês e a se conectar com novas pessoas e experiências.",
      text: "Nossa equipe dedicada tem trabalhado diligentemente para oferecer o melhor para nossos alunos, indo além das aulas de inglês. Nosso objetivo é oferecer uma experiência inesquecível de estudo no exterior. Para alcançar isso, oferecemos suporte personalizado aos estudantes, professores altamente qualificados e um ambiente cultural imersivo.",
    },
    accreditations: "Associados <span class='text-blue2'>& Credenciais</span>",
    media: {
      title: "Biblioteca de Mídia <span class='text-green2'>Library</span>",
      subtitle:
        "Aqui, você encontrará informações para nos conhecer melhor. Descubra detalhes sobre nossos campi, missão, cursos, níveis, vida estudantil, informações sobre visto, atividades extras e aulas.",
      text: "Nosso calendário inclui datas de início de cursos, feriados e datas oficiais de exames. E, é claro, você terá uma visão de perto de nossa escola através de nossas imagens e vídeos.",
      items: [
        {
          title: "Brochura do NED College",
          description:
            "Baixe aqui nossa brochura digital, que inclui detalhes sobre nossos campi, missão, cursos, vida estudantil e atividades extras e aulas.",
          link: "#brochure",
        },
        {
          title: "Lista de Preços",
          description: "Baixe a Lista de Preços Anual do NED College 2023/2024",
          link: "#pricelist",
        },
        {
          title: "Calendário",
          description: "Baixe nosso calendário 2024 para Dublin e Limerick",
          link: "#calendar",
        },
        {
          title: "Galeria de Vídeos",
          description:
            "Baixe vídeos de alta qualidade de nossos campi, alunos, atividades e muito mais",
          link: "#videogallery",
        },
        {
          title: "Galeria de Imagens",
          description:
            "Baixe imagens de alta qualidade de nossos campi, alunos, atividades e muito mais",
          link: "#imagegallery",
        },
        {
          title: "Material Gráfico",
          description: "Baixe nossos logotipos e material gráfico",
          link: "#graphicmaterial",
        },
      ],
    },
    brochure: {
      title: "Brochura da NED College",
      subtitle:
        "Baixe aqui nossa brochura digital, que inclui detalhes sobre nossos campi, missão, cursos, vida estudantil e atividades e aulas extras",
      items: [
        {
          title: "Versão em inglês",
          image: "brochure-en",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EWme5bnmNOtMqXymLGwRyQQBs9YC938Zc_Y1ZypepuQv-Q?e=LyUUQV",
        },
        {
          title: "Versão em espanhol",
          image: "brochure-es",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EZUVnEk1BFROtqdDw4wq5lcBaDPXGUdZ-khAP09SUqHdmQ?e=gTx9lS",
        },
        {
          title: "Versão em português",
          image: "brochure-pt",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EV95jhfHGhtBgEMYH_fQK6cBSuzRDRTHBax9cvYTdrrzaw?e=AIdF3L",
        },
        {
          title: "Versão em chinês",
          image: "brochure-en",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/Eb-YCRFk3jdPtUF3cbO4ye0BMnIXbUcuGCu9_0WG_ZatgA?e=Jtc9Ou",
        },
        {
          title: "Versão em mongol",
          image: "brochure-mg",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/ESAgdnGY7H1Ei60cWc5_IW8BrkpiBiXulx9fu3tkSm4fTQ?e=cPpHsA",
        },
      ],
    },
    pricelist: {
      title: "Lista de Preços",
      subtitle: "Baixe a Lista de Preços Anual do NED College 2023 / 2024",
      items: [
        {
          title: "Lista de Preços 2023 / 2024",
          image: "pricelist",
          link: "https://docs.google.com/presentation/d/e/2PACX-1vT8CHNyzX3jCOfTEKofimlXBiOZb7mHjfk1gu7Kp-pfYKxjK5MErzKMYIL4pOZMbvYEscT3s8Ciko8F/pub?start=false&loop=false&delayms=3000",
        },
      ],
    },
    calendar: {
      title: "Calendário",
      subtitle: "Baixe nosso calendário de 2024 para Dublin e Limerick",
      items: [
        {
          title: "Versão Dublin e Limerick",
          image: "calendário",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EUvJOgqHKBlKsgtKtIKEmlgBAzeJbBE6Ben6I7R6ZOOLEw?e=7zcxtQ",
        },
      ],
    },
    videos: {
      title: "Galeria de Vídeos",
      subtitle:
        "Baixe vídeos de alta qualidade de nossos campi, estudantes, atividades e muito mais",
      items: [
        {
          title: "Institucional Dublin",
          image: "institutional-dublin",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/ET7zhcWRP9pPogf3nnF5d7YBB5U4F_6Z92KcUNdgPcVHRw?e=wbcbUT",
        },
        {
          title: "Institucional Limerick",
          image: "institutional-limerick",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/EUMgORzPrmVDvDKMwybnIBYBtO6wUCqmGURnenlLwlt_dA?e=HW7V8P&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZyIsInJlZmVycmFsQXBwUGxhdGZvcm0iOiJXZWIiLCJyZWZlcnJhbE1vZGUiOiJ2aWV3In19",
        },
        {
          title: "Eaquals 2023",
          image: "eaquals-2023",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/ETqnTHuHZ4pLtzrd0DSOk20BsU_X3hibBVdlUHJ3cJ1C1A?e=ISwNMi",
        },
        {
          title: "NED College 10 anos",
          image: "ned-10-years",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/EadXawYqmcZCiDRveuslLoUBFxFPUWA5xz69agcCZ7feaQ?e=GNOL0g",
        },
        {
          title: "BeNED 2023",
          image: "bened-2023",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/EfdsWeUiEPlNgXDt7HNygDEB5zMstUNOMOxCey02qHwPMg?e=qn8TK4",
        },
      ],
    },
    images: {
      title: "Galeria de Imagens",
      subtitle: "Baixe imagens de alta qualidade dos nossos campi, estudantes, atividades e mais",
      dublin: {
        title: "Campus de Dublin",
        link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/Eho8B1G9ahRLtQf3B5bNoNMBqHBBB_6FdCf9Qr2PBkZtcA?e=BNYHez",
        items: [
          "gallery-dublin-1",
          "gallery-dublin-2",
          "gallery-dublin-3",
          "gallery-dublin-4",
          "gallery-dublin-5",
          "gallery-dublin-6",
          "gallery-dublin-7",
          "gallery-dublin-8",
          "gallery-dublin-9",
          "gallery-dublin-10",
          "gallery-dublin-11",
          "gallery-dublin-12",
          "gallery-dublin-13",
          "gallery-dublin-14",
        ],
      },
      limerick: {
        title: "Campus de Limerick",
        link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/Eh__OO3JlBdPvJwEXCR2RDwBA66bishS4TNCPr1Nus8Zjw?e=FUKHU9",
        items: [
          "gallery-limerick-1",
          "gallery-limerick-2",
          "gallery-limerick-3",
          "gallery-limerick-4",
          "gallery-limerick-5",
          "gallery-limerick-6",
          "gallery-limerick-7",
          "gallery-limerick-8",
          "gallery-limerick-9",
        ],
      },
    },
    material: {
      title: "Material Gráfico",
      subtitle: "Baixe nossos logos e material gráfico",
      items: [
        {
          title: "Versão Completa Principal",
          image: "graphic-mat-main-complete-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/Eq8zA9YJsGxAqmnPW-nUhicBzHI724v27zVppJX8Oo0x8Q?e=wV4PS1",
        },
        {
          title: "Versão Ícone Principal",
          image: "graphic-mat-main-icon-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/EoymnbheQ4tIn0aYTrckceYBRV6YcgRff2hHe2fRHyI1gg?e=a6bKhR",
        },
        {
          title: "Versão Completa Secundária",
          image: "graphic-mat-secondary-complete-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/EkGxlVnd5Y9EnsS6qOn163UBI0MTzns7NB7VdYI7T7z8ZA?e=HMMbJy",
        },
        {
          title: "Versão Ícone Secundária",
          image: "graphic-mat-secondary-icon-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/EnSpYoHSDNhKhIv9L5BwzyoB0esoGM9nk6J7hk7C5geirw?e=IUbmsz",
        },
        {
          title: "Diretrizes da Marca NED",
          image: "graphic-mat-brand-guidelines",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EUrSJ4DVF-xIh1Y6TPKUCawBzTHX25c_m2bWFRN6lMGwJQ?e=yYUt58",
        },
      ],
    },
    footer: {
      title: "Queremos ouvir <span class='text-green2'>de você!</span>",
      subtitle:
        "Se você quer colaborar conosco, não hesite em entrar em contato. Estamos ansiosos para ouvir suas ideias!",
      button: "Entre em Contato",
    },
    back_to_top: "Voltar para o topo",
  },
  thank_you: {
    title: "Obrigado <span class='text-green3'>por entrar em contato!</span>",
    subtitle: "Nossa equipe entrará em contato em breve!",
    card: {
      title: "Enquanto isso",
      body: "Por que não descobrir mais sobre nós, explorar nossos campi de Dublin e Limerick, ou seguir nossas redes sociais",
    },
  },
  mapsection: {
    title1: "Apoio ao Estudante em ",
    title2: "sua própria Língua",
    text: "No NED College, oferecemos suporte aos nossos estudantes antes de sua chegada e durante seu período de estudo na Irlanda. Todas as informações sobre o curso, visto, acomodação, transporte público, autorização de trabalho e como aproveitar ao máximo sua experiência em Dublin e Limerick serão fornecidas.",
    button: "Fale com nossos agentes!",
  },
  splitted_center: {
    title1: "Escolhendo",
    title2: "entre",
  },
  testimonialsection: {
    title: "Depoimentos dos Estudantes",
  },
  teamsection: {
    title: "Conheça nossa equipe de vendas",
    text1: "Campus / Escritórios",
    text2: "Encontre seu agente aqui",
    text3:
      "Orgulhamo-nos de ter uma equipe de vendas diversa e multicultural, dedicada a ajudar estudantes de todo o mundo a virem e experimentarem as incríveis oportunidades que a Irlanda tem a oferecer. Seja para melhorar suas habilidades linguísticas, explorar uma nova cultura ou buscar suas aspirações acadêmicas ou profissionais, nossa equipe está aqui para apoiá-lo em cada etapa do caminho.",
    locations: [
      {
        value: "dublin",
        label: "Campus de Dublin",
      },
      {
        value: "limerick",
        label: "Campus de Limerick",
      },
      {
        value: "chile",
        label: "Escritório no Chile",
      },
      {
        value: "uruguay",
        label: "Escritório no Uruguai",
      },
    ],
    team: [
      {
        image: "staff_22",
        name: "Alam Grace",
        subtitle: "Agente de Vendas Paraguai",
        flag: "paraguay",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Amarsaikhan Batsambuu",
        subtitle: "Agente de Vendas Mongólia",
        flag: "mongolia",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Daniela Peña",
        subtitle: "Agente de Vendas México",
        flag: "mexico",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Beatriz Cassão",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_1",
        name: "Carolina Rojas",
        subtitle: "Agente de Vendas Costa Rica",
        flag: "costa_rica",
        location: "dublin",
      },
      {
        image: "staff_3",
        name: "Deniz Imark",
        subtitle: "Agente de Vendas Turquia",
        flag: "turkey",
        location: "dublin",
      },
      {
        image: "staff_17",
        name: "Dhiogo Lunardelli",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_13",
        name: "Irina Nikicink",
        subtitle: "Agente de Vendas Paraguai",
        flag: "paraguay",
        location: "dublin",
      },
      {
        image: "staff_19",
        name: "Larissa Rossi Samuel",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_18",
        name: "Marina Contreras",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "dublin",
      },
      {
        image: "staff_15",
        name: "Mayra Weber",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_14",
        name: "Otavio Damaceno",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Otavio Magdaleno",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_12",
        name: "Tserenlkham Agi",
        subtitle: "Agente de Vendas Mongólia",
        flag: "mongolia",
        location: "dublin",
      },
      {
        image: "staff_16",
        name: "Vitor Britto",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_10",
        name: "Camila Vogel",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Chong Rong",
        subtitle: "Agente de Vendas Malásia",
        flag: "malaysia",
        location: "limerick",
      },
      {
        image: "staff_6",
        name: "Erik Beltrane",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "limerick",
      },
      {
        image: "staff_11",
        name: "Gabriela Iramendi",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Matheus de Oliveira",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_5",
        name: "Melissa Avila",
        subtitle: "Agente de Vendas Costa Rica",
        flag: "costa_rica",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Rhayane Caldeira",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_7",
        name: "Tiago Wagner",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Waldo Ramos",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Constanza Del Río",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Daniela Henríquez",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Cristal Perez",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_2",
        name: "Florencia Hidalgo",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_4",
        name: "Eduardo Fernández",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Natalia Smith",
        subtitle: "Agente de Vendas Uruguai",
        flag: "uruguay",
        location: "uruguay",
      },
      {
        image: "staff_25",
        name: "Paula Piriz",
        subtitle: "Agente de Vendas Uruguai",
        flag: "uruguay",
        location: "uruguay",
      },
      {
        image: "staff_23",
        name: "Manuela Amato",
        subtitle: "Agente de Vendas Uruguai",
        flag: "uruguay",
        location: "uruguay",
      },
      {
        image: "staff_default",
        name: "Anudari Erdenetsogt",
        subtitle: "Agente de Vendas Mongólia",
        flag: "mongolia",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Charles Michael Osowski",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Francine Mendez",
        subtitle: "Agente de Vendas Costa Rica",
        flag: "costa_rica",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Germano Santana",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Ho Li Peng",
        subtitle: "Agente de Vendas Malásia",
        flag: "malaysia",
        location: "Limerick",
      },
      {
        image: "staff_default",
        name: "Ingryd Lima",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Les Monárdez",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Manuela mardones",
        subtitle: "Agente de Vendas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Marcos Souza",
        subtitle: "Agente de Vendas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Melissa Rojas",
        subtitle: "Agente de Vendas Costa Rica",
        flag: "costa_rica",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Tiffany Chong Nyet Jun",
        subtitle: "Agente de Vendas Malásia",
        flag: "malaysia",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Wee Yee Lau",
        subtitle: "Agente de Vendas Malásia",
        flag: "malaysia",
        location: "dublin",
      },
    ],
  },
  topbar: {
    button: "Obter uma cotação!",
    icon: "PR",
  },
  contactform: {
    name: "Seu Nome Completo",
    address: "Seu Endereço de Email",
    phone: "Seu Número de Telefone",
    label1: "Por favor, selecione sua nacionalidade",
    label2: "Por favor, selecione o país onde você está atualmente morando",
    label3: "Onde você está no planejamento do seu estudo de inglês no exterior?",
    label5: "Selecione o programa que você está procurando",
    label4: "Em qual campus você deseja estudar?",
    message: "Se você quiser escrever algo, sinta-se à vontade",
    steps: [
      {
        value: "Apenas pesquisando e tentando entender sobre estudar no exterior",
        label: "Apenas pesquisando e tentando entender sobre estudar no exterior",
      },
      {
        value: "Eu sei o quanto posso investir, mas não sei o destino e/ou escola",
        label: "Eu sei o quanto posso investir, mas não sei o destino e/ou escola",
      },
      {
        value: "Financeiramente preparado e decidindo em qual escola estudar",
        label: "Financeiramente preparado e decidindo em qual escola estudar",
      },
    ],
    campuses: [
      {
        value: "dublin",
        label: "Campus Dublin",
      },
      {
        value: "limerick",
        label: "Campus Limerick",
      },
      {
        value: "didnt_decide",
        label: "Ainda não decidi",
      },
    ],
    programmes: [
      {
        value: "first_general",
        label: "Primeiro curso - Inglês Geral",
      },
      {
        value: "first_ielts",
        label: "Primeiro curso - Preparação para o IELTS",
      },
      {
        value: "ren_general",
        label: "Renovação - Curso de Inglês Geral",
      },
      {
        value: "ren_ielts",
        label: "Renovação - Curso de Preparação para o IELTS",
      },
    ],
    button: "Enviar!",
    success_msg: "Obrigado, sua mensagem foi enviada!",
  },
  english_test: {
    title: "Teste seu Inglês",
    breadcr: ["Teste seu Inglês"],
    subtitle: "Teste de Nivelamento Online",
    description: "Avalie sua proficiência em inglês com nosso teste de nivelamento online gratuito. Isso nos ajudará a determinar seu nível atual e recomendar o curso mais adequado para você.",
    form_title: "Por favor, preencha o formulário abaixo para iniciar seu teste.",
    form_fields: {
      name: "Nome Completo",
      email: "E-mail",
      phone: "Número de Telefone",
      country: "País",
      nationality: "Nacionalidade",
      course: "Curso de Interesse",
      select_country: "Selecione seu país",
      select_nationality: "Selecione sua nacionalidade",
      select_course: "Selecione um curso",
      submit_button: "Iniciar o Teste"
    },
    test_title: "Teste de Nivelamento de Inglês",
    test_description: "Responda às seguintes perguntas para nos ajudar a avaliar seu nível de proficiência em inglês.",
    test_completed_title: "Teste Concluído!",
    test_completed_message: "Obrigado por completar nosso teste de nivelamento de inglês. Nossa equipe analisará seus resultados e entrará em contato em breve com recomendações de cursos adaptados ao seu nível de proficiência.",
    return_home: "Voltar para a Página Inicial"
  },
  footer: {
    title: "Descarregue o nosso Folheto",
    text: "Conheça tudo sobre estudar na Irlanda com o NED College!",
    button: "Descarregar agora",
    ireland: "República da Irlanda",
    download_d: "Descarregue a nossa aplicação de Dublin",
    download_l: "Descarregue a nossa aplicação de Limerick",
    opening: "Horário de Funcionamento",
    days: "Segunda a Sexta-feira",
    days1: "das 9:00 às 16:30",
    email: "Email",
    refund: "Pedido de Nota de Crédito e Reembolso",
    terms: "Termos e Condições",
    privacy: "Política de Privacidade",
    download: "Descarregue o nosso Folheto",
    subtitlemodal: "Conheça tudo sobre estudar na Irlanda com o NED College!",
  },
};
